/* Made at Tue Feb 19 2019 17:28:07 GMT+0900 (GMT+09:00) */
const json = 

[
	{
		"title": "「＜俺による永久革命＞の復活ーー『平岡正明論』刊行記念イベント」",
		"members": [
			"大谷能生",
			"速水健朗"
		],
		"date": "2018/07/01",
		"url": "https://vimeo.com/ondemand/genron20180701",
		"rawString": "「＜俺による永久革命＞の復活ーー『平岡正明論』刊行記念イベント」\t大谷能生、速水健朗\t2018/07/01\thttps://vimeo.com/ondemand/genron20180701"
	},
	{
		"title": "「現代音楽」に未来はあるか？──『やさしい現代音楽の作曲法』刊行記念イベント",
		"members": [
			"川島素晴",
			"渋谷慶一郎",
			"新垣隆",
			"木石岳"
		],
		"date": "2018/07/04",
		"url": "https://vimeo.com/ondemand/genron20180704",
		"rawString": "「現代音楽」に未来はあるか？──『やさしい現代音楽の作曲法』刊行記念イベント\t川島素晴、渋谷慶一郎、新垣隆、木石岳\t2018/07/04\thttps://vimeo.com/ondemand/genron20180704"
	},
	{
		"title": "【ゲンロンカフェ＠VOLVO STUDIO AOYAMA#7】1998年から2038年へ──消費と都市と交通から日本の20年前と20年後を考える",
		"members": [
			"宇野維正",
			"速水健朗",
			"東浩紀"
		],
		"date": "2018/05/30",
		"url": "https://vimeo.com/ondemand/genron20180530",
		"rawString": "【ゲンロンカフェ＠VOLVO STUDIO AOYAMA#7】1998年から2038年へ──消費と都市と交通から日本の20年前と20年後を考える\t宇野維正、速水健朗、東浩紀\t2018/05/30\thttps://vimeo.com/ondemand/genron20180530"
	},
	{
		"title": "「7年後のいまをどう伝えるかーー『原発事故と「食」』（中公新書）刊行記念」",
		"members": [
			"五十嵐泰正",
			"小松理虔",
			"武田徹"
		],
		"date": "2018/04/25",
		"url": "https://vimeo.com/ondemand/genron20180425",
		"rawString": "「7年後のいまをどう伝えるかーー『原発事故と「食」』（中公新書）刊行記念」\t五十嵐泰正、小松理虔、武田徹\t2018/04/25\thttps://vimeo.com/ondemand/genron20180425"
	},
	{
		"title": "【四天王シリーズ #2】ゲーム、美術、キャラクター！ーー『ゲンロン8 ゲームの時代』刊行記念イベント",
		"members": [
			"黒瀬陽平",
			"さやわか",
			"松下哲也"
		],
		"date": "2018/06/20",
		"url": "https://vimeo.com/ondemand/genron20180620",
		"rawString": "【四天王シリーズ #2】ゲーム、美術、キャラクター！ーー『ゲンロン8 ゲームの時代』刊行記念イベント\t黒瀬陽平、さやわか、松下哲也\t2018/06/20\thttps://vimeo.com/ondemand/genron20180620"
	},
	{
		"title": "【ゲンロンカフェ at VOLVO STUDIO AOYAMA #4】廃墟とユートピア――チェルノブイリツアーのアクチュアリティ",
		"members": [
			"東浩紀",
			"上田洋子"
		],
		"date": "2018/06/29",
		"url": "https://vimeo.com/ondemand/genron20180629",
		"rawString": "【ゲンロンカフェ at VOLVO STUDIO AOYAMA #4】廃墟とユートピア――チェルノブイリツアーのアクチュアリティ\t東浩紀、上田洋子\t2018/06/29\thttps://vimeo.com/ondemand/genron20180629"
	},
	{
		"title": "『仏教論争――「縁起」から本質を問う』（ちくま新書）刊行記念イベント",
		"members": [
			"宮崎哲弥",
			"村山正司"
		],
		"date": "2018/05/22",
		"url": "https://vimeo.com/ondemand/genron20180522",
		"rawString": "『仏教論争――「縁起」から本質を問う』（ちくま新書）刊行記念イベント\t宮崎哲弥、村山正司\t2018/05/22\thttps://vimeo.com/ondemand/genron20180522"
	},
	{
		"title": "【四天王シリーズ #1】ゲンロンはどこから来て、どこに行くのか――爆誕した四天王がおおいに語る批評の未来【カフェ5周年】",
		"members": [
			"大澤聡",
			"黒瀬陽平",
			"さやわか",
			"吉田雅史"
		],
		"date": "2018/05/14",
		"url": "https://vimeo.com/ondemand/genron20180514",
		"rawString": "【四天王シリーズ #1】ゲンロンはどこから来て、どこに行くのか――爆誕した四天王がおおいに語る批評の未来【カフェ5周年】\t大澤聡、黒瀬陽平、さやわか、吉田雅史\t2018/05/14\thttps://vimeo.com/ondemand/genron20180514"
	},
	{
		"title": "【ゲンロンカフェ＠VOLVO STUDIO AOYAMA #6】都市と道の写真論",
		"members": [
			"大山顕",
			"東浩紀"
		],
		"date": "2018/04/22",
		"url": "https://vimeo.com/ondemand/genron20180422",
		"rawString": "【ゲンロンカフェ＠VOLVO STUDIO AOYAMA #6】都市と道の写真論\t大山顕、東浩紀\t2018/04/22\thttps://vimeo.com/ondemand/genron20180422"
	},
	{
		"title": "デラシネの倫理と観光客の哲学――『デラシネの時代』（角川新書）刊行記念イベント",
		"members": [
			"五木寛之",
			"東浩紀",
			"沼野充義"
		],
		"date": "2018/04/20",
		"url": "https://vimeo.com/ondemand/genron20180420",
		"rawString": "デラシネの倫理と観光客の哲学――『デラシネの時代』（角川新書）刊行記念イベント\t五木寛之、東浩紀、沼野充義\t2018/04/20\thttps://vimeo.com/ondemand/genron20180420"
	},
	{
		"title": "【ポスト映画論講義 #5】ホラー表現と物語——『スクリプトドクター』と『フェイクドキュメンタリー作家』徹底対論！",
		"members": [
			"白石晃士",
			"三宅隆太",
			"渡邉大輔"
		],
		"date": "2018/04/10",
		"url": "https://vimeo.com/ondemand/genron20180410",
		"rawString": "【ポスト映画論講義 #5】ホラー表現と物語——『スクリプトドクター』と『フェイクドキュメンタリー作家』徹底対論！\t白石晃士、三宅隆太、渡邉大輔\t2018/04/10\thttps://vimeo.com/ondemand/genron20180410"
	},
	{
		"title": "マンガとアニメーションとリアリズム――『個人的なハーモニー』から考える",
		"members": [
			"土居伸彰",
			"三輪健太朗",
			"宮本大人"
		],
		"date": "2018/04/04",
		"url": "https://vimeo.com/ondemand/genron20180404",
		"rawString": "マンガとアニメーションとリアリズム――『個人的なハーモニー』から考える\t土居伸彰、三輪健太朗、宮本大人\t2018/04/04\thttps://vimeo.com/ondemand/genron20180404"
	},
	{
		"title": "情報テクノロジーと医療のゆくえ――『ぼくらの未来をつくる仕事』（かんき出版）刊行記念イベント",
		"members": [
			"豊田剛一郎",
			"津田大介"
		],
		"date": "2018/03/16",
		"url": "https://vimeo.com/ondemand/genron20180316",
		"rawString": "情報テクノロジーと医療のゆくえ――『ぼくらの未来をつくる仕事』（かんき出版）刊行記念イベント\t豊田剛一郎、津田大介\t2018/03/16\thttps://vimeo.com/ondemand/genron20180316"
	},
	{
		"title": "『日本思想』の再設定 ――西郷隆盛と三木清から考える明治維新150年",
		"members": [
			"大澤聡",
			"先崎彰容",
			"東浩紀"
		],
		"date": "2018/03/13",
		"url": "https://vimeo.com/ondemand/genron20180313",
		"rawString": "『日本思想』の再設定 ――西郷隆盛と三木清から考える明治維新150年\t大澤聡、先崎彰容、東浩紀\t2018/03/13\thttps://vimeo.com/ondemand/genron20180313"
	},
	{
		"title": "仮想通貨と人工知能――技術は経済を変えるのか？",
		"members": [
			"井上智洋",
			"楠正憲",
			"塚越健司"
		],
		"date": "2018/03/09",
		"url": "https://vimeo.com/ondemand/genron20180309a",
		"rawString": "仮想通貨と人工知能――技術は経済を変えるのか？\t井上智洋、楠正憲、塚越健司\t2018/03/09\thttps://vimeo.com/ondemand/genron20180309a"
	},
	{
		"title": "なぜ選挙は茶番になるのか？――『なぜ政治はわかりにくいのか』（春秋社）刊行記念イベント",
		"members": [
			"西田亮介",
			"曽我部真裕"
		],
		"date": "2018/02/27",
		"url": "https://vimeo.com/ondemand/genron20180227",
		"rawString": "なぜ選挙は茶番になるのか？――『なぜ政治はわかりにくいのか』（春秋社）刊行記念イベント\t西田亮介、曽我部真裕\t2018/02/27\thttps://vimeo.com/ondemand/genron20180227"
	},
	{
		"title": "【ゲンロンカフェ at VOLVO STUDIO AOYAMA #4】2020以前／以後——東京はこれからどうすべきか",
		"members": [
			"‏夏野剛",
			"東浩紀"
		],
		"date": "2018/02/21",
		"url": "https://vimeo.com/ondemand/genron20180221",
		"rawString": "【ゲンロンカフェ at VOLVO STUDIO AOYAMA #4】2020以前／以後——東京はこれからどうすべきか\t‏夏野剛、東浩紀\t2018/02/21\thttps://vimeo.com/ondemand/genron20180221"
	},
	{
		"title": "【ゲンロンカフェ開業5周年記念企画！】「東浩紀おおいに語る」",
		"members": [
			"東浩紀",
			"坂上秋成",
			"吉田雅史"
		],
		"date": "2018/02/14",
		"url": "https://vimeo.com/ondemand/genron20180214",
		"rawString": "【ゲンロンカフェ開業5周年記念企画！】「東浩紀おおいに語る」\t東浩紀、坂上秋成、吉田雅史\t2018/02/14\thttps://vimeo.com/ondemand/genron20180214"
	},
	{
		"title": "サイバーパンク放談 #2 ーー『ブレードランナー2049』は傑作なのか、あともろもろ",
		"members": [
			"佐藤大",
			"さやわか",
			"東浩紀"
		],
		"date": "2018/02/09",
		"url": "https://vimeo.com/ondemand/genron20180209",
		"rawString": "サイバーパンク放談 #2 ーー『ブレードランナー2049』は傑作なのか、あともろもろ\t佐藤大、さやわか、東浩紀\t2018/02/09\thttps://vimeo.com/ondemand/genron20180209"
	},
	{
		"title": "【ゲンロンカフェ at VOLVO STUDIO AOYAMA #3】あいちトリエンナーレと芸術の現在",
		"members": [
			"津田大介",
			"東浩紀"
		],
		"date": "2018/01/28",
		"url": "https://vimeo.com/ondemand/genron20180128",
		"rawString": "【ゲンロンカフェ at VOLVO STUDIO AOYAMA #3】あいちトリエンナーレと芸術の現在\t津田大介、東浩紀\t2018/01/28\thttps://vimeo.com/ondemand/genron20180128"
	},
	{
		"title": "いま、日本現代美術に何が起こっているのか #2.5ーー個と集団から考える現代美術",
		"members": [
			"田中功起",
			"梅津庸一",
			"黒瀬陽平"
		],
		"date": "2018/01/26",
		"url": "https://vimeo.com/ondemand/genron20180126",
		"rawString": "いま、日本現代美術に何が起こっているのか #2.5ーー個と集団から考える現代美術\t田中功起、梅津庸一、黒瀬陽平\t2018/01/26\thttps://vimeo.com/ondemand/genron20180126"
	},
	{
		"title": "カントと孟子が語り合うーー『道徳を基礎づける』講談社学術文庫版刊行記念トークイベント",
		"members": [
			"中島隆博",
			"東浩紀"
		],
		"date": "2018/01/18",
		"url": "https://vimeo.com/ondemand/genron20180118",
		"rawString": "カントと孟子が語り合うーー『道徳を基礎づける』講談社学術文庫版刊行記念トークイベント\t中島隆博、東浩紀\t2018/01/18\thttps://vimeo.com/ondemand/genron20180118"
	},
	{
		"title": "ショッピングモールはテロを誘発するのか？――『スマホの写真論』から見たラスベガス【ショッピングモールから考える #7】",
		"members": [
			"大山顕",
			"東浩紀"
		],
		"date": "2018/01/11",
		"url": "https://vimeo.com/ondemand/genron20180111",
		"rawString": "ショッピングモールはテロを誘発するのか？――『スマホの写真論』から見たラスベガス【ショッピングモールから考える #7】\t大山顕、東浩紀\t2018/01/11\thttps://vimeo.com/ondemand/genron20180111"
	},
	{
		"title": "ヒップホップは何を変えてきたのか",
		"members": [
			"磯部涼",
			"Kダブシャイン",
			"吉田雅史"
		],
		"date": "2017/12/26",
		"url": "https://vimeo.com/ondemand/genron20171226",
		"rawString": "ヒップホップは何を変えてきたのか\t磯部涼、Kダブシャイン、吉田雅史\t2017/12/26\thttps://vimeo.com/ondemand/genron20171226"
	},
	{
		"title": "2017年海外SFが復活した！――新訳『すばらしい新世界』『銀河の壺直し』＆『Ｊ・Ｇ・バラード短編全集』刊行記念対談【大森望のSF喫茶 特別編】",
		"members": [
			"大森望",
			"柳下毅一郎"
		],
		"date": "2017/12/23",
		"url": "https://vimeo.com/ondemand/genron20171223sf",
		"rawString": "2017年海外SFが復活した！――新訳『すばらしい新世界』『銀河の壺直し』＆『Ｊ・Ｇ・バラード短編全集』刊行記念対談【大森望のSF喫茶 特別編】\t大森望、柳下毅一郎\t2017/12/23\thttps://vimeo.com/ondemand/genron20171223sf"
	},
	{
		"title": "2017年徹底総括！ おれたちはポピュリズムに勝てるのか——『「ポスト真実」の時代』刊行記念対談【ニッポンの放談 #3】",
		"members": [
			"津田大介",
			"東浩紀"
		],
		"date": "2017/12/24",
		"url": "https://vimeo.com/ondemand/genron20171224",
		"rawString": "2017年徹底総括！ おれたちはポピュリズムに勝てるのか——『「ポスト真実」の時代』刊行記念対談【ニッポンの放談 #3】\t津田大介、東浩紀\t2017/12/24\thttps://vimeo.com/ondemand/genron20171224"
	},
	{
		"title": "【ゲンロンカフェ＠VOLVO STUDIO AOYAMA #2】いま哲学の場所はどこにあるのか",
		"members": [
			"國分功一郎",
			"東浩紀"
		],
		"date": "2017/12/10",
		"url": "https://vimeo.com/ondemand/genron20171210",
		"rawString": "【ゲンロンカフェ＠VOLVO STUDIO AOYAMA #2】いま哲学の場所はどこにあるのか\t國分功一郎、東浩紀\t2017/12/10\thttps://vimeo.com/ondemand/genron20171210"
	},
	{
		"title": "暴力の歴史から未来のゲームへ ――小川哲『ゲームの王国』刊行記念イベント【大森望のSF喫茶 #25】",
		"members": [
			"小川哲",
			"山形浩生",
			"大森望"
		],
		"date": "2017/11/28",
		"url": "https://vimeo.com/ondemand/genron20171128",
		"rawString": "暴力の歴史から未来のゲームへ ――小川哲『ゲームの王国』刊行記念イベント【大森望のSF喫茶 #25】\t小川哲、山形浩生、大森望\t2017/11/28\thttps://vimeo.com/ondemand/genron20171128"
	},
	{
		"title": "一般文字学は可能か ──記号論と脳科学の新しい展開をめぐって #3",
		"members": [
			"石田英敬",
			"東浩紀"
		],
		"date": "2017/11/24",
		"url": "https://vimeo.com/ondemand/genron20171124",
		"rawString": "一般文字学は可能か ──記号論と脳科学の新しい展開をめぐって #3\t石田英敬、東浩紀\t2017/11/24\thttps://vimeo.com/ondemand/genron20171124"
	},
	{
		"title": "いま、日本現代美術に何が起こっているのか #2",
		"members": [
			"加治屋健司",
			"新藤淳",
			"黒瀬陽平",
			"梅沢和木",
			"藤城噓"
		],
		"date": "2017/11/21",
		"url": "https://vimeo.com/ondemand/genron20171121",
		"rawString": "いま、日本現代美術に何が起こっているのか #2\t加治屋健司、新藤淳、黒瀬陽平、梅沢和木、藤城噓\t2017/11/21\thttps://vimeo.com/ondemand/genron20171121"
	},
	{
		"title": "【ニッポンの展望 #6】2017・秋の陣",
		"members": [
			"宮台真司",
			"東浩紀"
		],
		"date": "2017/11/20",
		"url": "https://vimeo.com/ondemand/genron20171120",
		"rawString": "【ニッポンの展望 #6】2017・秋の陣\t宮台真司、東浩紀\t2017/11/20\thttps://vimeo.com/ondemand/genron20171120"
	},
	{
		"title": "【ゲンロンカフェ＠VOLVO STUDIO AOYAMA #1】『観光客の哲学』と都市文化――第71回毎日出版文化賞受賞記念講演",
		"members": [
			"東浩紀"
		],
		"date": "2017/11/15",
		"url": "https://vimeo.com/ondemand/genron20171115",
		"rawString": "【ゲンロンカフェ＠VOLVO STUDIO AOYAMA #1】『観光客の哲学』と都市文化――第71回毎日出版文化賞受賞記念講演\t東浩紀\t2017/11/15\thttps://vimeo.com/ondemand/genron20171115"
	},
	{
		"title": "日本は本当に核を持つべきなのか",
		"members": [
			"三浦瑠麗",
			"津田大介",
			"東浩紀"
		],
		"date": "2017/10/25",
		"url": "https://vimeo.com/ondemand/genron20171025",
		"rawString": "日本は本当に核を持つべきなのか\t三浦瑠麗、津田大介、東浩紀\t2017/10/25\thttps://vimeo.com/ondemand/genron20171025"
	},
	{
		"title": "哲学と映像の『存在論的転回』——『実在への殺到』と『映像の境域』の交点から考える【ポスト映画論講義 #4】",
		"members": [
			"金子遊",
			"清水高志",
			"渡邉大輔"
		],
		"date": "2017/10/14",
		"url": "https://vimeo.com/ondemand/genron20171014",
		"rawString": "哲学と映像の『存在論的転回』——『実在への殺到』と『映像の境域』の交点から考える【ポスト映画論講義 #4】 \t金子遊、清水高志、渡邉大輔\t2017/10/14\thttps://vimeo.com/ondemand/genron20171014"
	},
	{
		"title": "メディア／都市／コンテンツ——『1990年代論』から考える",
		"members": [
			"五十嵐太郎",
			"さやわか",
			"大澤聡"
		],
		"date": "2017/10/06",
		"url": "https://vimeo.com/ondemand/genron20171006",
		"rawString": "メディア／都市／コンテンツ——『1990年代論』から考える\t五十嵐太郎、さやわか、大澤聡\t2017/10/06\thttps://vimeo.com/ondemand/genron20171006"
	},
	{
		"title": "バフチンからポストモダンへ――『ゲンロン6 ロシア現代思想Ⅰ』刊行記念トークショー",
		"members": [
			"貝澤哉",
			"乗松亨平",
			"東浩紀"
		],
		"date": "2017/09/30",
		"url": "https://vimeo.com/ondemand/genron20170930",
		"rawString": "バフチンからポストモダンへ――『ゲンロン6 ロシア現代思想Ⅰ』刊行記念トークショー\t貝澤哉、乗松亨平、東浩紀\t2017/09/30\thttps://vimeo.com/ondemand/genron20170930"
	},
	{
		"title": "数字が語らないことを語りたいーー『リスクと生きる、死者と生きる』刊行記念トークショー",
		"members": [
			"石戸諭×小松理虔"
		],
		"date": "2017/09/29",
		"url": "https://vimeo.com/ondemand/genron20170929",
		"rawString": "数字が語らないことを語りたいーー『リスクと生きる、死者と生きる』刊行記念トークショー\t石戸諭×小松理虔\t2017/09/29\thttps://vimeo.com/ondemand/genron20170929"
	},
	{
		"title": "分ける、つなぐ、で考える——分類と系統樹から見える世界",
		"members": [
			"三中信宏",
			"山本貴光",
			"吉川浩満"
		],
		"date": "2017/09/01",
		"url": "https://vimeo.com/ondemand/genron20171014",
		"rawString": "分ける、つなぐ、で考える——分類と系統樹から見える世界\t三中信宏、山本貴光、吉川浩満\t2017/09/01\thttps://vimeo.com/ondemand/genron20171014"
	},
	{
		"title": "『忘れられた』戦争・日中戦争のすべて（1937〜1945年）ーー最新研究で主要戦闘・主要事件総まくり【愛国コンテンツの未来学 #8】",
		"members": [
			"広中一成",
			"辻田真佐憲"
		],
		"date": "2017/08/17",
		"url": "https://vimeo.com/ondemand/genron20170817",
		"rawString": "『忘れられた』戦争・日中戦争のすべて（1937〜1945年）ーー最新研究で主要戦闘・主要事件総まくり【愛国コンテンツの未来学 #8】\t広中一成、辻田真佐憲\t2017/08/17\thttps://vimeo.com/ondemand/genron20170817"
	},
	{
		"title": "鉄道の思想と観光の思想――『ゲンロン0 観光客の哲学』から考える、第3弾！",
		"members": [
			"原武史",
			"速水健朗",
			"東浩紀"
		],
		"date": "2017/08/10",
		"url": "https://vimeo.com/ondemand/genron20170810",
		"rawString": "鉄道の思想と観光の思想――『ゲンロン0 観光客の哲学』から考える、第3弾！\t原武史、速水健朗、東浩紀\t2017/08/10\thttps://vimeo.com/ondemand/genron20170810"
	},
	{
		"title": "サイバーパンク・リバイバルーー復活した没入（ジャック・イン）的想像力とその可能性【さやわか式☆現代文化論 #30】",
		"members": [
			"佐藤大",
			"さやわか",
			"東浩紀"
		],
		"date": "2017/08/04",
		"url": "https://vimeo.com/ondemand/genron20170804",
		"rawString": "サイバーパンク・リバイバルーー復活した没入（ジャック・イン）的想像力とその可能性【さやわか式☆現代文化論 #30】\t佐藤大、さやわか、東浩紀\t2017/08/04\thttps://vimeo.com/ondemand/genron20170804"
	},
	{
		"title": "小松左京が復活する？！ ーーSFアマチュア読者2人がそれぞれの仕事と絡めて考える偉人の現代的可能性",
		"members": [
			"木ノ下裕一",
			"東浩紀"
		],
		"date": "2017/07/28",
		"url": "https://vimeo.com/ondemand/genron20170728",
		"rawString": "小松左京が復活する？！ ーーSFアマチュア読者2人がそれぞれの仕事と絡めて考える偉人の現代的可能性\t木ノ下裕一、東浩紀\t2017/07/28\thttps://vimeo.com/ondemand/genron20170728"
	},
	{
		"title": "福島は思想的課題になりえたか――浜通り通信全50回完結記念トーク",
		"members": [
			"小松理虔",
			"津田大介",
			"東浩紀"
		],
		"date": "2017/07/21",
		"url": "https://vimeo.com/ondemand/genron20170721",
		"rawString": "福島は思想的課題になりえたか――浜通り通信全50回完結記念トーク\t小松理虔、津田大介、東浩紀\t2017/07/21\thttps://vimeo.com/ondemand/genron20170721"
	},
	{
		"title": "勉強、モテ、権威——コミュニケーション論としての『勉強の哲学』",
		"members": [
			"千葉雅也　聞き手=入江哲朗"
		],
		"date": "2017/07/14",
		"url": "https://vimeo.com/ondemand/genron20170714",
		"rawString": "勉強、モテ、権威——コミュニケーション論としての『勉強の哲学』\t千葉雅也　聞き手=入江哲朗\t2017/07/14\thttps://vimeo.com/ondemand/genron20170714"
	},
	{
		"title": "国道は謎だらけ——道路を行けば日本が見える？！",
		"members": [
			"佐藤健太郎",
			"大山顕"
		],
		"date": "2017/07/11",
		"url": "https://vimeo.com/ondemand/genron20170711",
		"rawString": "国道は謎だらけ——道路を行けば日本が見える？！\t佐藤健太郎、大山顕\t2017/07/11\thttps://vimeo.com/ondemand/genron20170711"
	},
	{
		"title": "『ゲンロン0 観光客の哲学』刊行記念 東浩紀2日連続トークイベント ──出張ゲンロンカフェ2日目・大阪篇（主催：ジュンク堂書店大阪本店／ゲンロン）",
		"members": [
			"東浩紀"
		],
		"date": "2017/07/01",
		"url": "https://vimeo.com/ondemand/genron20170701",
		"rawString": "『ゲンロン0 観光客の哲学』刊行記念 東浩紀2日連続トークイベント ──出張ゲンロンカフェ2日目・大阪篇（主催：ジュンク堂書店大阪本店／ゲンロン）\t東浩紀\t2017/07/01\thttps://vimeo.com/ondemand/genron20170701"
	},
	{
		"title": "『ゲンロン0 観光客の哲学』刊行記念 東浩紀2日連続トークイベント ――出張ゲンロンカフェ1日目・福岡篇（主催：ジュンク堂書店福岡店／ゲンロン）",
		"members": [
			"東浩紀"
		],
		"date": "2017/06/30",
		"url": "https://vimeo.com/ondemand/genron20170630",
		"rawString": "『ゲンロン0 観光客の哲学』刊行記念 東浩紀2日連続トークイベント ――出張ゲンロンカフェ1日目・福岡篇（主催：ジュンク堂書店福岡店／ゲンロン）\t東浩紀\t2017/06/30\thttps://vimeo.com/ondemand/genron20170630"
	},
	{
		"title": "三島由紀夫と宇宙人？――映画『美しい星』公開記念トークイベント",
		"members": [
			"吉田大八",
			"斎藤環",
			"佐々木敦"
		],
		"date": "2017/06/12",
		"url": "https://vimeo.com/ondemand/genron20170612",
		"rawString": "三島由紀夫と宇宙人？――映画『美しい星』公開記念トークイベント\t吉田大八、斎藤環、佐々木敦\t2017/06/12\thttps://vimeo.com/ondemand/genron20170612"
	},
	{
		"title": "「美術館という地雷原——それらは不発のままで保たれうるか？」",
		"members": [
			"岡﨑乾二郎",
			"岡田温司",
			"土屋誠一"
		],
		"date": "2017/06/02",
		"url": "https://vimeo.com/ondemand/genron20170602",
		"rawString": "「美術館という地雷原——それらは不発のままで保たれうるか？」\t岡﨑乾二郎、岡田温司、土屋誠一\t2017/06/02\thttps://vimeo.com/ondemand/genron20170602"
	},
	{
		"title": "続・一般文字学は可能か――記号論と脳科学の新しい展開をめぐって",
		"members": [
			"石田英敬",
			"東浩紀"
		],
		"date": "2017/05/24",
		"url": "https://vimeo.com/ondemand/genron20170524",
		"rawString": "続・一般文字学は可能か――記号論と脳科学の新しい展開をめぐって\t石田英敬、東浩紀\t2017/05/24\thttps://vimeo.com/ondemand/genron20170524"
	},
	{
		"title": "VRは私たちに何をもたらすのか？——変わりゆく＜現実（リアリティ）＞と、その社会的インパクトについて",
		"members": [
			"井上明人",
			"鳴海拓志",
			"黒瀬洋平"
		],
		"date": "2017/04/26",
		"url": "https://vimeo.com/ondemand/genron20170426",
		"rawString": "VRは私たちに何をもたらすのか？——変わりゆく＜現実（リアリティ）＞と、その社会的インパクトについて\t井上明人、鳴海拓志、黒瀬洋平\t2017/04/26\thttps://vimeo.com/ondemand/genron20170426"
	},
	{
		"title": "ついに出た！『ゲンロン0』世界最速読書会！！――『観光客の哲学』を読む",
		"members": [
			"東浩紀"
		],
		"date": "2017/04/11",
		"url": "https://vimeo.com/ondemand/genron20170411",
		"rawString": "ついに出た！『ゲンロン0』世界最速読書会！！――『観光客の哲学』を読む\t東浩紀\t2017/04/11\thttps://vimeo.com/ondemand/genron20170411"
	},
	{
		"title": "息づく体験、蘇る記憶——ダークツーリズムとアーカイブがつなぐ歴史",
		"members": [
			"井出明",
			"小松理虔",
			"渡邉英徳"
		],
		"date": "2017/03/28",
		"url": "https://vimeo.com/ondemand/genron20170328",
		"rawString": "息づく体験、蘇る記憶——ダークツーリズムとアーカイブがつなぐ歴史\t井出明、小松理虔、渡邉英徳\t2017/03/28\thttps://vimeo.com/ondemand/genron20170328"
	},
	{
		"title": "POST-TRUTH時代の現代思想——60歳を迎えた浅田彰と語る、21世紀の新世界秩序",
		"members": [
			"浅田彰",
			"千葉雅也",
			"東浩紀"
		],
		"date": "2017/03/25",
		"url": "https://vimeo.com/ondemand/genron20170325",
		"rawString": "POST-TRUTH時代の現代思想——60歳を迎えた浅田彰と語る、21世紀の新世界秩序\t浅田彰、千葉雅也、東浩紀\t2017/03/25\thttps://vimeo.com/ondemand/genron20170325"
	},
	{
		"title": "日本／東京から聖地巡礼を考える——宗教的聖地とアニメ聖地はどう違うのか？",
		"members": [
			"五十嵐太郎",
			"岡本亮輔",
			"室井康成"
		],
		"date": "2017/03/07",
		"url": "https://vimeo.com/ondemand/genron170307",
		"rawString": "日本／東京から聖地巡礼を考える——宗教的聖地とアニメ聖地はどう違うのか？\t五十嵐太郎、岡本亮輔、室井康成\t2017/03/07\thttps://vimeo.com/ondemand/genron170307"
	},
	{
		"title": "批評という快楽——『日本批評大全』徹底解剖",
		"members": [
			"渡部直己",
			"大澤聡"
		],
		"date": "2017/03/03",
		"url": "https://vimeo.com/ondemand/genron20170303",
		"rawString": "批評という快楽——『日本批評大全』徹底解剖\t渡部直己、大澤聡\t2017/03/03\thttps://vimeo.com/ondemand/genron20170303"
	},
	{
		"title": "日本映画と海外ドラマ、いま、どちらを見るべきなのか",
		"members": [
			"黒瀬陽平",
			"渡邉大輔"
		],
		"date": "2017/02/28",
		"url": "https://vimeo.com/ondemand/genron20170228",
		"rawString": "日本映画と海外ドラマ、いま、どちらを見るべきなのか\t黒瀬陽平、渡邉大輔\t2017/02/28\thttps://vimeo.com/ondemand/genron20170228"
	},
	{
		"title": "一般文字学は可能か——記号論と脳科学の新しい展開をめぐって",
		"members": [
			"石田英敬",
			"東浩紀"
		],
		"date": "2017/02/17",
		"url": "https://vimeo.com/ondemand/genron20170217",
		"rawString": "一般文字学は可能か——記号論と脳科学の新しい展開をめぐって\t石田英敬、東浩紀\t2017/02/17\thttps://vimeo.com/ondemand/genron20170217"
	},
	{
		"title": "ユートピアと日常の共産主義建築──地下鉄、団地、チェルノブイリ",
		"members": [
			"大山顕",
			"本田晃子",
			"上田洋子"
		],
		"date": "2017/02/15",
		"url": "https://vimeo.com/ondemand/genron20170215",
		"rawString": "ユートピアと日常の共産主義建築──地下鉄、団地、チェルノブイリ\t大山顕、本田晃子、上田洋子\t2017/02/15\thttps://vimeo.com/ondemand/genron20170215"
	},
	{
		"title": "【愛国コンテンツの未来学 #7】反日プロパガンダ、歴史戦、あるいは——日中戦争開戦80周年 いまこそ通州事件と南京事件を問い直す",
		"members": [
			"辻田真佐憲",
			"広中一成"
		],
		"date": "2017/02/10",
		"url": "https://vimeo.com/ondemand/genron20170210",
		"rawString": "【愛国コンテンツの未来学 #7】反日プロパガンダ、歴史戦、あるいは——日中戦争開戦80周年 いまこそ通州事件と南京事件を問い直す\t辻田真佐憲、広中一成\t2017/02/10\thttps://vimeo.com/ondemand/genron20170210"
	},
	{
		"title": "さやわか式☆ベストハンドレッド 2017【さやわか式☆現代文化論 #29】",
		"members": [
			"さやわか"
		],
		"date": "2017/02/09",
		"url": "https://vimeo.com/ondemand/genron20170209",
		"rawString": "さやわか式☆ベストハンドレッド 2017【さやわか式☆現代文化論 #29】\tさやわか\t2017/02/09\thttps://vimeo.com/ondemand/genron20170209"
	},
	{
		"title": "2017年、世界はどこへ向かうのか——『「トランプ時代」の新世界秩序』（潮新書）刊行記念トーク",
		"members": [
			"三浦瑠麗",
			"津田大介",
			"東浩紀"
		],
		"date": "2017/02/01",
		"url": "https://vimeo.com/ondemand/genron20170201",
		"rawString": "2017年、世界はどこへ向かうのか——『「トランプ時代」の新世界秩序』（潮新書）刊行記念トーク\t三浦瑠麗、津田大介、東浩紀\t2017/02/01\thttps://vimeo.com/ondemand/genron20170201"
	},
	{
		"title": "アニメーション的想像力の現在：ノルシュテインから『この世界の片隅に』まで——『個人的なハーモニー』（フィルムアート社）刊行記念イベント",
		"members": [
			"佐々木敦",
			"土居伸彰"
		],
		"date": "2017/01/31",
		"url": "https://vimeo.com/ondemand/genron20170131",
		"rawString": "アニメーション的想像力の現在：ノルシュテインから『この世界の片隅に』まで——『個人的なハーモニー』（フィルムアート社）刊行記念イベント\t佐々木敦、土居伸彰\t2017/01/31\thttps://vimeo.com/ondemand/genron20170131"
	},
	{
		"title": "【ニッポンの演劇 #8】「あなた」と構築する世界の物語——ロロと演劇の魔法",
		"members": [
			"三浦直之（ロロ）",
			"佐々木敦"
		],
		"date": "2017/01/25",
		"url": "https://vimeo.com/ondemand/genron20170125",
		"rawString": "【ニッポンの演劇 #8】「あなた」と構築する世界の物語——ロロと演劇の魔法\t三浦直之（ロロ）、佐々木敦\t2017/01/25\thttps://vimeo.com/ondemand/genron20170125"
	},
	{
		"title": "今、日本現代美術に何が起こっているのか——『ニューカマーアーティスト』から見る美術の地勢図",
		"members": [
			"梅津庸一",
			"蔵屋美香",
			"黒瀬陽平",
			"齋藤恵汰"
		],
		"date": "2017/01/24",
		"url": "https://vimeo.com/ondemand/genron20170124",
		"rawString": "今、日本現代美術に何が起こっているのか——『ニューカマーアーティスト』から見る美術の地勢図\t梅津庸一、蔵屋美香、黒瀬陽平、齋藤恵汰\t2017/01/24\thttps://vimeo.com/ondemand/genron20170124"
	},
	{
		"title": "マンガを再生する——ひらめき☆マンガ教室キックオフイベント",
		"members": [
			"さやわか",
			"西島大介",
			"東浩紀"
		],
		"date": "2017/01/20",
		"url": "https://vimeo.com/ondemand/genron20170120",
		"rawString": "マンガを再生する——ひらめき☆マンガ教室キックオフイベント\tさやわか、西島大介、東浩紀\t2017/01/20\thttps://vimeo.com/ondemand/genron20170120"
	},
	{
		"title": "「現代日本の批評 1975-2016」再考——共同討議全3回完結記念",
		"members": [
			"安藤礼二",
			"大澤聡",
			"杉田俊介",
			"東浩紀"
		],
		"date": "2017/01/13",
		"url": "https://vimeo.com/ondemand/genron20170113",
		"rawString": "「現代日本の批評 1975-2016」再考——共同討議全3回完結記念\t安藤礼二、大澤聡、杉田俊介、東浩紀\t2017/01/13\thttps://vimeo.com/ondemand/genron20170113"
	},
	{
		"title": "物語の選択と運命の決定──『未知との遭遇【完全版】』刊行記念対談",
		"members": [
			"佐々木敦",
			"冲方丁"
		],
		"date": "2016/12/19",
		"url": "https://vimeo.com/ondemand/genron20161219",
		"rawString": "物語の選択と運命の決定──『未知との遭遇【完全版】』刊行記念対談\t佐々木敦、冲方丁\t2016/12/19\thttps://vimeo.com/ondemand/genron20161219"
	},
	{
		"title": "【ニッポンの展望 特別編】トランプの時代をどう生きるか",
		"members": [
			"津田大介",
			"宮台真司",
			"東浩紀"
		],
		"date": "2016/12/17",
		"url": "https://vimeo.com/ondemand/genron20161217",
		"rawString": "【ニッポンの展望 特別編】トランプの時代をどう生きるか\t津田大介、宮台真司、東浩紀\t2016/12/17\thttps://vimeo.com/ondemand/genron20161217"
	},
	{
		"title": "【大森望のSF喫茶#23】『自生の夢』刊行記念トークイベント",
		"members": [
			"大森望",
			"飛浩隆",
			"東浩紀"
		],
		"date": "2016/12/10",
		"url": "https://vimeo.com/ondemand/genron20161210",
		"rawString": "【大森望のSF喫茶#23】『自生の夢』刊行記念トークイベント\t大森望、飛浩隆、東浩紀\t2016/12/10\thttps://vimeo.com/ondemand/genron20161210"
	},
	{
		"title": "『人文的、あまりに人文的』な、2016年人文書めった斬り！",
		"members": [
			"斎藤哲也",
			"山本貴光",
			"吉川浩満"
		],
		"date": "2016/12/07",
		"url": "https://vimeo.com/ondemand/genron20161207",
		"rawString": "『人文的、あまりに人文的』な、2016年人文書めった斬り！\t斎藤哲也、山本貴光、吉川浩満\t2016/12/07\thttps://vimeo.com/ondemand/genron20161207"
	},
	{
		"title": "ラップは『いま』を映しているか——BLM、大統領選から日本語ラップ・ブームまで",
		"members": [
			"大和田俊之",
			"磯部涼",
			"吉田雅史"
		],
		"date": "2016/11/25",
		"url": "https://vimeo.com/ondemand/genron20161125",
		"rawString": "ラップは『いま』を映しているか——BLM、大統領選から日本語ラップ・ブームまで\t大和田俊之、磯部涼、吉田雅史\t2016/11/25\thttps://vimeo.com/ondemand/genron20161125"
	},
	{
		"title": "【ニッポンの演劇 #7】現代演劇の地図を描くために——『「J演劇」の場所』刊行記念トークショー",
		"members": [
			"内野儀",
			"佐々木敦"
		],
		"date": "2016/11/24",
		"url": "https://vimeo.com/ondemand/genron20161124",
		"rawString": "【ニッポンの演劇 #7】現代演劇の地図を描くために——『「J演劇」の場所』刊行記念トークショー\t内野儀、佐々木敦\t2016/11/24\thttps://vimeo.com/ondemand/genron20161124"
	},
	{
		"title": "「2016年晩秋の巻」【ニッポンの脳 #6】",
		"members": [
			"茂木健一郎",
			"東浩紀"
		],
		"date": "2016/11/21",
		"url": "https://vimeo.com/ondemand/genron20161121",
		"rawString": "「2016年晩秋の巻」【ニッポンの脳 #6】\t茂木健一郎、東浩紀\t2016/11/21\thttps://vimeo.com/ondemand/genron20161121"
	},
	{
		"title": "【ニッポンの演劇 #6】亡国の演劇LOVE——東京デスロックが継ぐ「演技と演出」",
		"members": [
			"多田淳之介",
			"佐々木敦"
		],
		"date": "2016/11/04",
		"url": "https://vimeo.com/ondemand/genron20161104",
		"rawString": "【ニッポンの演劇 #6】亡国の演劇LOVE——東京デスロックが継ぐ「演技と演出」\t多田淳之介、佐々木敦\t2016/11/04\thttps://vimeo.com/ondemand/genron20161104"
	},
	{
		"title": "ほんとうの本の読みかた——『百学連環』から知を再編成する",
		"members": [
			"大澤聡",
			"山本貴光"
		],
		"date": "2016/10/28",
		"url": "https://vimeo.com/ondemand/genron20161028",
		"rawString": "ほんとうの本の読みかた——『百学連環』から知を再編成する\t大澤聡、山本貴光\t2016/10/28\thttps://vimeo.com/ondemand/genron20161028"
	},
	{
		"title": "演劇、映画行政、そして世界へ──深田晃司監督最新作『淵に立つ』カンヌ受賞記念企画【ポスト映画論講義#3】",
		"members": [
			"深田晃司",
			"渡邉大輔"
		],
		"date": "2016/10/15",
		"url": "https://vimeo.com/ondemand/genron20161015",
		"rawString": "演劇、映画行政、そして世界へ──深田晃司監督最新作『淵に立つ』カンヌ受賞記念企画【ポスト映画論講義#3】\t深田晃司、渡邉大輔\t2016/10/15\thttps://vimeo.com/ondemand/genron20161015"
	},
	{
		"title": "青木理×久田将義×東浩紀「『噂の眞相』とは何だったのか——「現代日本の批評」番外編」【ニッポンの闇 #2】",
		"members": [
			"青木理",
			"久田将義",
			"東浩紀"
		],
		"date": "2016/09/27",
		"url": "https://vimeo.com/ondemand/genron20160927",
		"rawString": "青木理×久田将義×東浩紀「『噂の眞相』とは何だったのか——「現代日本の批評」番外編」【ニッポンの闇 #2】\t青木理、久田将義、東浩紀\t2016/09/27\thttps://vimeo.com/ondemand/genron20160927"
	},
	{
		"title": "「ニッポンの展望#5 2016・秋の陣」",
		"members": [
			"宮台真司",
			"東浩紀"
		],
		"date": "2016/09/21",
		"url": "https://vimeo.com/ondemand/genron20160921",
		"rawString": "「ニッポンの展望#5 2016・秋の陣」\t宮台真司、東浩紀\t2016/09/21\thttps://vimeo.com/ondemand/genron20160921"
	},
	{
		"title": "日本の未来とポピュリズム",
		"members": [
			"三浦瑠麗",
			"津田大介",
			"東浩紀"
		],
		"date": "2016/09/07",
		"url": "https://vimeo.com/ondemand/genron20160907",
		"rawString": "日本の未来とポピュリズム\t三浦瑠麗、津田大介、東浩紀\t2016/09/07\thttps://vimeo.com/ondemand/genron20160907"
	},
	{
		"title": "ゼロ年代以降に批評はあったのか——「現代日本の批評」2001-2016を収録直後の討議メンバーが語る批評の15年",
		"members": [
			"大澤聡",
			"佐々木敦",
			"さやわか",
			"東浩紀"
		],
		"date": "2016/08/14",
		"url": "https://vimeo.com/ondemand/genron20160814",
		"rawString": "ゼロ年代以降に批評はあったのか——「現代日本の批評」2001-2016を収録直後の討議メンバーが語る批評の15年\t大澤聡、佐々木敦、さやわか、東浩紀\t2016/08/14\thttps://vimeo.com/ondemand/genron20160814"
	},
	{
		"title": "ポピュリズムの台頭とリベラルの対抗戦略——21世紀に民主主義は可能か",
		"members": [
			"山口二郎",
			"津田大介",
			"東浩紀"
		],
		"date": "2016/08/05",
		"url": "https://vimeo.com/ondemand/genron20160805",
		"rawString": "ポピュリズムの台頭とリベラルの対抗戦略——21世紀に民主主義は可能か\t山口二郎、津田大介、東浩紀\t2016/08/05\thttps://vimeo.com/ondemand/genron20160805"
	},
	{
		"title": "沖縄の新聞は本当に「偏向」しているのか",
		"members": [
			"安田浩一",
			"仲村良太（琉球新報）",
			"宮城栄作（沖縄タイムス）",
			"初沢亜利"
		],
		"date": "2016/08/02",
		"url": "https://vimeo.com/ondemand/genron20160802",
		"rawString": "沖縄の新聞は本当に「偏向」しているのか\t安田浩一、仲村良太（琉球新報）、宮城栄作（沖縄タイムス）、初沢亜利\t2016/08/02\thttps://vimeo.com/ondemand/genron20160802"
	},
	{
		"title": "カリフ制再興 vs 一般意志2.0——民主主義はこれからどうなるのか？",
		"members": [
			"中田考",
			"東浩紀"
		],
		"date": "2016/07/28",
		"url": "https://vimeo.com/ondemand/genron20160728",
		"rawString": "カリフ制再興 vs 一般意志2.0——民主主義はこれからどうなるのか？\t中田考、東浩紀\t2016/07/28\thttps://vimeo.com/ondemand/genron20160728"
	},
	{
		"title": "新・東京から考える",
		"members": [
			"速水健朗",
			"東浩紀",
			"浅子佳英"
		],
		"date": "2016/07/08",
		"url": "https://vimeo.com/ondemand/genron20160708",
		"rawString": "新・東京から考える\t速水健朗、東浩紀、浅子佳英\t2016/07/08\thttps://vimeo.com/ondemand/genron20160708"
	},
	{
		"title": "2016夏休み ダークツーリズムガイド――ニコニコ動画 ”DARKtourism JAPAN開設記念”",
		"members": [
			"井出明"
		],
		"date": "2016/07/01",
		"url": "https://vimeo.com/ondemand/genron20160701",
		"rawString": "2016夏休み ダークツーリズムガイド――ニコニコ動画 ”DARKtourism JAPAN開設記念”\t井出明\t2016/07/01\thttps://vimeo.com/ondemand/genron20160701"
	},
	{
		"title": "【ニッポンの放談 #1】相次ぐ災害、参院選、沖縄、そしてネット炎上——ゆるふわジャーナリスト津田大介が『やる気なし』東浩紀に直撃インタビュー、的な？",
		"members": [
			"津田大介",
			"東浩紀"
		],
		"date": "2016/06/29",
		"url": "https://vimeo.com/ondemand/genron20160629",
		"rawString": "【ニッポンの放談 #1】相次ぐ災害、参院選、沖縄、そしてネット炎上——ゆるふわジャーナリスト津田大介が『やる気なし』東浩紀に直撃インタビュー、的な？\t津田大介、東浩紀\t2016/06/29\thttps://vimeo.com/ondemand/genron20160629"
	},
	{
		"title": "津田大介×東浩紀「【ニッポンの放談 #1】相次ぐ災害、参院選、沖縄、そしてネット炎上——ゆるふわジャーナリスト津田大介が『やる気なし』東浩紀に直撃インタビュー、的な？」 @tsuda @hazuma",
		"members": [
			"津田大介",
			"東浩紀"
		],
		"date": "2016/06/29",
		"url": "https://vimeo.com/ondemand/genron20160629",
		"rawString": "津田大介×東浩紀「【ニッポンの放談 #1】相次ぐ災害、参院選、沖縄、そしてネット炎上——ゆるふわジャーナリスト津田大介が『やる気なし』東浩紀に直撃インタビュー、的な？」 @tsuda @hazuma\t津田大介、東浩紀\t2016/06/29\thttps://vimeo.com/ondemand/genron20160629"
	},
	{
		"title": "【ニッポンの演劇 #4】現代口語演劇はいかに更新されたか？",
		"members": [
			"平田オリザ",
			"佐々木敦"
		],
		"date": "2016/06/28",
		"url": "https://vimeo.com/ondemand/genron20160628",
		"rawString": "【ニッポンの演劇 #4】現代口語演劇はいかに更新されたか？\t平田オリザ、佐々木敦\t2016/06/28\thttps://vimeo.com/ondemand/genron20160628"
	},
	{
		"title": "地域アートは自由の夢を見るか？——藤田直哉編著『地域アート』刊行記念イベント",
		"members": [
			"藤井光",
			"藤田直哉",
			"東浩紀"
		],
		"date": "2016/06/09",
		"url": "https://vimeo.com/ondemand/genron20160609",
		"rawString": "地域アートは自由の夢を見るか？——藤田直哉編著『地域アート』刊行記念イベント\t藤井光、藤田直哉、東浩紀\t2016/06/09\thttps://vimeo.com/ondemand/genron20160609"
	},
	{
		"title": "越境する近代日本——満州・韓国取材から見えてきたもの：『ゲンロン3 脱戦後日本美術』キックオフイベント",
		"members": [
			"安藤礼二",
			"黒瀬陽平",
			"東浩紀"
		],
		"date": "2016/06/03",
		"url": "https://vimeo.com/ondemand/genron20160603",
		"rawString": "越境する近代日本——満州・韓国取材から見えてきたもの：『ゲンロン3 脱戦後日本美術』キックオフイベント\t安藤礼二、黒瀬陽平、東浩紀\t2016/06/03\thttps://vimeo.com/ondemand/genron20160603"
	},
	{
		"title": "2016年初夏の巻【ニッポンの脳 #5】",
		"members": [
			"茂木健一郎",
			"東浩紀"
		],
		"date": "2016/05/31",
		"url": "https://vimeo.com/ondemand/genron20160531",
		"rawString": "2016年初夏の巻【ニッポンの脳 #5】\t茂木健一郎、東浩紀\t2016/05/31\thttps://vimeo.com/ondemand/genron20160531"
	},
	{
		"title": "人工知能最前線！ シンギュラリティ前夜に機械は幸福の夢を見るか——『明日、機械がヒトになる』（講談社現代新書）刊行記念イベント",
		"members": [
			"海猫沢めろん",
			"長谷敏司"
		],
		"date": "2016/05/24",
		"url": "https://vimeo.com/ondemand/genron20160524",
		"rawString": "人工知能最前線！ シンギュラリティ前夜に機械は幸福の夢を見るか——『明日、機械がヒトになる』（講談社現代新書）刊行記念イベント\t海猫沢めろん、長谷敏司\t2016/05/24\thttps://vimeo.com/ondemand/genron20160524"
	},
	{
		"title": "アメリカ大統領選の行方——トランプは大統領になってしまうのか、なったとしてどうなるのか？",
		"members": [
			"海野素央",
			"津田大介",
			"東浩紀"
		],
		"date": "2016/05/20",
		"url": "https://vimeo.com/ondemand/genron20160520",
		"rawString": "アメリカ大統領選の行方——トランプは大統領になってしまうのか、なったとしてどうなるのか？\t海野素央、津田大介、東浩紀\t2016/05/20\thttps://vimeo.com/ondemand/genron20160520"
	},
	{
		"title": "ラディカルな芸術とはなにか——芸術祭におけるアーティストと観客",
		"members": [
			"鴻英良",
			"危口統之",
			"黒瀬陽平"
		],
		"date": "2016/04/28",
		"url": "https://vimeo.com/ondemand/genron20160428",
		"rawString": "ラディカルな芸術とはなにか——芸術祭におけるアーティストと観客\t鴻英良、危口統之、黒瀬陽平\t2016/04/28\thttps://vimeo.com/ondemand/genron20160428"
	},
	{
		"title": "初代総代がいきなり登場！ 批評再生塾はぶっちゃけ成功だったのか、第2期はなにが変わるのか。批評再生塾第1期贈賞式＆第2期キックオフイベント",
		"members": [
			"佐々木敦",
			"吉田雅史",
			"東浩紀"
		],
		"date": "2016/04/27",
		"url": "https://vimeo.com/ondemand/genron20160427",
		"rawString": "初代総代がいきなり登場！ 批評再生塾はぶっちゃけ成功だったのか、第2期はなにが変わるのか。批評再生塾第1期贈賞式＆第2期キックオフイベント\t佐々木敦、吉田雅史、東浩紀\t2016/04/27\thttps://vimeo.com/ondemand/genron20160427"
	},
	{
		"title": "【ポスト映画論講義 #2】いま、映画は「政治的」たりうるか——ポスト映画と社会の新しい関わりをめぐって",
		"members": [
			"北小路隆志",
			"渡邉大輔"
		],
		"date": "2016/04/22",
		"url": "https://vimeo.com/ondemand/genron20160422",
		"rawString": "【ポスト映画論講義 #2】いま、映画は「政治的」たりうるか——ポスト映画と社会の新しい関わりをめぐって\t北小路隆志、渡邉大輔\t2016/04/22\thttps://vimeo.com/ondemand/genron20160422"
	},
	{
		"title": "【愛国コンテンツの未来学 #5】プロパガンダとしての観光——帝国日本の「聖地巡礼」から中国レッドツーリズムまで",
		"members": [
			"辻田真佐憲"
		],
		"date": "2016/04/15",
		"url": "https://vimeo.com/ondemand/genron20160415",
		"rawString": "【愛国コンテンツの未来学 #5】プロパガンダとしての観光——帝国日本の「聖地巡礼」から中国レッドツーリズムまで\t辻田真佐憲\t2016/04/15\thttps://vimeo.com/ondemand/genron20160415"
	},
	{
		"title": "写真が伝える未来の幻影——30年後のチェルノブイリとフォトジャーナリズム",
		"members": [
			"小原一真",
			"東浩紀",
			"上田洋子"
		],
		"date": "2016/04/14",
		"url": "https://vimeo.com/ondemand/genron20160414",
		"rawString": "写真が伝える未来の幻影——30年後のチェルノブイリとフォトジャーナリズム\t小原一真、東浩紀、上田洋子\t2016/04/14\thttps://vimeo.com/ondemand/genron20160414"
	},
	{
		"title": "【ニッポンの演劇 #3】なにが演劇なのか——パフォーマンスの「正体」をめぐって",
		"members": [
			"飴屋法水",
			"佐々木敦"
		],
		"date": "2016/04/13",
		"url": "https://vimeo.com/ondemand/genron20160413",
		"rawString": "【ニッポンの演劇 #3】なにが演劇なのか——パフォーマンスの「正体」をめぐって\t飴屋法水、佐々木敦\t2016/04/13\thttps://vimeo.com/ondemand/genron20160413"
	},
	{
		"title": "【さやわか式☆現代文化論 #25】サブカル批評はキャラ概念で延命しうるか",
		"members": [
			"さやわか",
			"佐々木敦"
		],
		"date": "2016/03/31",
		"url": "https://vimeo.com/ondemand/genron20160331",
		"rawString": "【さやわか式☆現代文化論 #25】サブカル批評はキャラ概念で延命しうるか\tさやわか、佐々木敦\t2016/03/31\thttps://vimeo.com/ondemand/genron20160331"
	},
	{
		"title": "「断片」と「批評」のあいだで——日常世界を記述するためのレッスン",
		"members": [
			"大澤聡",
			"岸政彦"
		],
		"date": "2016/03/24",
		"url": "https://vimeo.com/ondemand/genron20160324",
		"rawString": "「断片」と「批評」のあいだで——日常世界を記述するためのレッスン\t大澤聡、岸政彦\t2016/03/24\thttps://vimeo.com/ondemand/genron20160324"
	},
	{
		"title": "「ニッポンの展望 #4 2016・春の陣」",
		"members": [
			"宮台真司",
			"東浩紀"
		],
		"date": "2016/03/23",
		"url": "https://vimeo.com/ondemand/genron20160323",
		"rawString": "「ニッポンの展望 #4 2016・春の陣」\t宮台真司、東浩紀\t2016/03/23\thttps://vimeo.com/ondemand/genron20160323"
	},
	{
		"title": "【ショッピングモールから考える #6】幻冬舎新書版刊行記念トークショー",
		"members": [
			"石川初",
			"大山顕",
			"三井祐介",
			"東浩紀"
		],
		"date": "2016/03/16",
		"url": "https://vimeo.com/ondemand/genron20160316",
		"rawString": "【ショッピングモールから考える #6】幻冬舎新書版刊行記念トークショー\t石川初、大山顕、三井祐介、東浩紀\t2016/03/16\thttps://vimeo.com/ondemand/genron20160316"
	},
	{
		"title": "日本で民主主義は機能したか？——西田亮介編『民主主義』（幻冬舎新書）刊行記念イベント",
		"members": [
			"西田亮介",
			"吉田徹"
		],
		"date": "2016/03/09",
		"url": "https://vimeo.com/ondemand/genron20160309",
		"rawString": "日本で民主主義は機能したか？——西田亮介編『民主主義』（幻冬舎新書）刊行記念イベント\t西田亮介、吉田徹\t2016/03/09\thttps://vimeo.com/ondemand/genron20160309"
	},
	{
		"title": "【東京国際文芸フェスティバル2016 オリジナルイベント】タイと日本の一般意志2.0——アジアにおける現代思想",
		"members": [
			"プラープダー・ユン",
			"東浩紀",
			"福冨渉"
		],
		"date": "2016/03/04",
		"url": "https://vimeo.com/ondemand/genron20160304",
		"rawString": "【東京国際文芸フェスティバル2016 オリジナルイベント】タイと日本の一般意志2.0——アジアにおける現代思想\tプラープダー・ユン、東浩紀、福冨渉\t2016/03/04\thttps://vimeo.com/ondemand/genron20160304"
	},
	{
		"title": "人文学は本当に危機なのか？——ポスト・ヒューマニティーズの文化地図作成法",
		"members": [
			"吉川浩満",
			"山本貴光"
		],
		"date": "2016/03/02",
		"url": "https://vimeo.com/ondemand/genron20160302",
		"rawString": "人文学は本当に危機なのか？——ポスト・ヒューマニティーズの文化地図作成法\t吉川浩満、山本貴光\t2016/03/02\thttps://vimeo.com/ondemand/genron20160302"
	},
	{
		"title": "ソロ男×男性学——結婚しない男たち、その生態と未来",
		"members": [
			"荒川和久",
			"田中俊之"
		],
		"date": "2016/02/17",
		"url": "https://vimeo.com/ondemand/genron20160217",
		"rawString": "ソロ男×男性学——結婚しない男たち、その生態と未来\t荒川和久、田中俊之\t2016/02/17\thttps://vimeo.com/ondemand/genron20160217"
	},
	{
		"title": "男たちが語る『スター・ウォーズ エピソードⅦ』——なぜハン・ソロはベンに一発食らわせないのか",
		"members": [
			"夏野剛",
			"黒瀬陽平",
			"東浩紀"
		],
		"date": "2016/02/16",
		"url": "https://vimeo.com/ondemand/genron20160216",
		"rawString": "男たちが語る『スター・ウォーズ エピソードⅦ』——なぜハン・ソロはベンに一発食らわせないのか\t夏野剛、黒瀬陽平、東浩紀\t2016/02/16\thttps://vimeo.com/ondemand/genron20160216"
	},
	{
		"title": "「原発再稼動、パリ同時多発テロ、衆参両院選挙……2016年、日本はそれでも変わらないのか？——『戦争・天皇・国家』＆『正義について考えよう』刊行記念トークイベント」 @inosenaoki @namatahara @hazuma @tsuda",
		"members": [
			"猪瀬直樹",
			"田原総一朗",
			"東浩紀",
			"津田大介"
		],
		"date": "2016/02/15",
		"url": "https://vimeo.com/ondemand/genron20160215",
		"rawString": "「原発再稼動、パリ同時多発テロ、衆参両院選挙……2016年、日本はそれでも変わらないのか？——『戦争・天皇・国家』＆『正義について考えよう』刊行記念トークイベント」 @inosenaoki @namatahara @hazuma @tsuda\t猪瀬直樹、田原総一朗、東浩紀、津田大介\t2016/02/15\thttps://vimeo.com/ondemand/genron20160215"
	},
	{
		"title": "【ニッポンの演劇 #2】舞台の時間が人生を露出する——ハイバイから考える現代口語演劇",
		"members": [
			"岩井秀人",
			"佐々木敦"
		],
		"date": "2016/02/10",
		"url": "https://vimeo.com/ondemand/genron20160210",
		"rawString": "【ニッポンの演劇 #2】舞台の時間が人生を露出する——ハイバイから考える現代口語演劇\t岩井秀人、佐々木敦\t2016/02/10\thttps://vimeo.com/ondemand/genron20160210"
	},
	{
		"title": "なつこんpresents 【大森望のSF喫茶 #20】エヴァンゲリオン〜西暦2016年 終局の続き",
		"members": [
			"大森望",
			"坂上秋成",
			"西田藍",
			"東浩紀"
		],
		"date": "2016/02/06",
		"url": "https://vimeo.com/ondemand/genron20160206",
		"rawString": "なつこんpresents 【大森望のSF喫茶 #20】エヴァンゲリオン〜西暦2016年 終局の続き\t大森望、坂上秋成、西田藍、東浩紀\t2016/02/06\thttps://vimeo.com/ondemand/genron20160206"
	},
	{
		"title": "フランク・ゲーリー・テクノロジーズの衝撃：想像力と3Dモデリング",
		"members": [
			"田根剛",
			"黒瀬陽平",
			"東浩紀"
		],
		"date": "2016/01/29",
		"url": "https://vimeo.com/ondemand/genron20160129",
		"rawString": "フランク・ゲーリー・テクノロジーズの衝撃：想像力と3Dモデリング\t田根剛、黒瀬陽平、東浩紀\t2016/01/29\thttps://vimeo.com/ondemand/genron20160129"
	},
	{
		"title": "建築からみる北京とモスクワ——共産主義建築のモニュメンタリティと祝祭性",
		"members": [
			"市川紘司",
			"本田晃子",
			"上田洋子"
		],
		"date": "2016/01/28",
		"url": "https://vimeo.com/ondemand/genron20160128",
		"rawString": "建築からみる北京とモスクワ——共産主義建築のモニュメンタリティと祝祭性\t市川紘司、本田晃子、上田洋子\t2016/01/28\thttps://vimeo.com/ondemand/genron20160128"
	},
	{
		"title": "【さやわか式☆現代文化論 #24】オタクの時代は終わった——『おたく神経サナトリウム』＆『キャラの思考法』刊行記念鼎談",
		"members": [
			"さやわか",
			"斎藤環",
			"東浩紀"
		],
		"date": "2016/01/27",
		"url": "https://vimeo.com/ondemand/genron20160127",
		"rawString": "【さやわか式☆現代文化論 #24】オタクの時代は終わった——『おたく神経サナトリウム』＆『キャラの思考法』刊行記念鼎談\tさやわか、斎藤環、東浩紀\t2016/01/27\thttps://vimeo.com/ondemand/genron20160127"
	},
	{
		"title": "「終末」と「核」から考える日本文化——『戦後サブカル年代記』と『核と日本人』をめぐって",
		"members": [
			"円堂都司昭",
			"山本昭宏"
		],
		"date": "2016/01/26",
		"url": "https://vimeo.com/ondemand/genron20160126",
		"rawString": "「終末」と「核」から考える日本文化——『戦後サブカル年代記』と『核と日本人』をめぐって\t円堂都司昭、山本昭宏\t2016/01/26\thttps://vimeo.com/ondemand/genron20160126"
	},
	{
		"title": "新しいSFが、ここから始まる。——＜ゲンロン 大森望 SF創作講座＞キックオフイベント",
		"members": [
			"大森望",
			"東浩紀",
			"坂上秋成",
			"小浜徹也",
			"塩澤快浩",
			"高山羽根子",
			"高野史緒"
		],
		"date": "2016/01/21",
		"url": "https://vimeo.com/ondemand/genron20160121",
		"rawString": "新しいSFが、ここから始まる。——＜ゲンロン 大森望 SF創作講座＞キックオフイベント\t大森望、東浩紀、坂上秋成、小浜徹也、塩澤快浩、高山羽根子、高野史緒\t2016/01/21\thttps://vimeo.com/ondemand/genron20160121"
	},
	{
		"title": "思弁的実在論の展開について——メイヤスー『有限性の後で』刊行直前対談",
		"members": [
			"千葉雅也",
			"東浩紀"
		],
		"date": "2016/01/15",
		"url": "https://vimeo.com/ondemand/genron20160115",
		"rawString": "思弁的実在論の展開について——メイヤスー『有限性の後で』刊行直前対談\t千葉雅也、東浩紀\t2016/01/15\thttps://vimeo.com/ondemand/genron20160115"
	},
	{
		"title": "演劇・戦争・民主主義——歴史と未来を結ぶ言葉と身体",
		"members": [
			"高橋源一郎",
			"藤田貴大"
		],
		"date": "2016/01/12",
		"url": "https://vimeo.com/ondemand/genron20160112",
		"rawString": "演劇・戦争・民主主義——歴史と未来を結ぶ言葉と身体\t高橋源一郎、藤田貴大\t2016/01/12\thttps://vimeo.com/ondemand/genron20160112"
	},
	{
		"title": "『火花』『絶歌』、そしてテロの時代——芥川賞からSFミステリまで、縦横無尽ジャンル無視の2015年文学全面総括徹底座談会！",
		"members": [
			"市川真人",
			"大森望",
			"佐々木敦",
			"東浩紀",
			"海猫沢めろん",
			"吉上亮"
		],
		"date": "2015/12/26",
		"url": "https://vimeo.com/ondemand/genron20151226",
		"rawString": "『火花』『絶歌』、そしてテロの時代——芥川賞からSFミステリまで、縦横無尽ジャンル無視の2015年文学全面総括徹底座談会！\t市川真人、大森望、佐々木敦、東浩紀、海猫沢めろん、吉上亮\t2015/12/26\thttps://vimeo.com/ondemand/genron20151226"
	},
	{
		"title": "【さやわか式☆現代文化論 #23】西島大介とセカイは変わったのか——『土曜日の実験室+ 詩と批評とあと何か』刊行記念対談",
		"members": [
			"さやわか",
			"西島大介"
		],
		"date": "2015/12/22",
		"url": "https://vimeo.com/ondemand/genron20151222",
		"rawString": "【さやわか式☆現代文化論 #23】西島大介とセカイは変わったのか——『土曜日の実験室+ 詩と批評とあと何か』刊行記念対談\tさやわか、西島大介\t2015/12/22\thttps://vimeo.com/ondemand/genron20151222"
	},
	{
		"title": "【ニッポンの演劇 #1】新しい日本語、新しい身体——チェルフィッチュと演劇の現在",
		"members": [
			"岡田利規",
			"佐々木敦"
		],
		"date": "2015/12/17",
		"url": "https://vimeo.com/ondemand/genron20151217",
		"rawString": "【ニッポンの演劇 #1】新しい日本語、新しい身体——チェルフィッチュと演劇の現在\t岡田利規、佐々木敦\t2015/12/17\thttps://vimeo.com/ondemand/genron20151217"
	},
	{
		"title": "自民党はもう負けないのか——『メディアと自民党』刊行記念トークショー",
		"members": [
			"平将明",
			"津田大介",
			"西田亮介"
		],
		"date": "2015/12/16",
		"url": "https://vimeo.com/ondemand/genron20151216",
		"rawString": "自民党はもう負けないのか——『メディアと自民党』刊行記念トークショー\t平将明、津田大介、西田亮介\t2015/12/16\thttps://vimeo.com/ondemand/genron20151216"
	},
	{
		"title": "「批評」とは何だったのか？——創刊号企画「現代日本の批評」参加メンバーが批評史を総括、『ゲンロン』創刊の展望を語る",
		"members": [
			"市川真人",
			"福嶋亮大",
			"東浩紀"
		],
		"date": "2015/12/11",
		"url": "https://vimeo.com/ondemand/genron20151211",
		"rawString": "「批評」とは何だったのか？——創刊号企画「現代日本の批評」参加メンバーが批評史を総括、『ゲンロン』創刊の展望を語る\t市川真人、福嶋亮大、東浩紀\t2015/12/11\thttps://vimeo.com/ondemand/genron20151211"
	},
	{
		"title": "2015年、井出明が歩いたダークツーリズムの足跡——『DARK tourism JAPAN Vol.2』刊行特別イベント",
		"members": [
			"井出明"
		],
		"date": "2015/12/09",
		"url": "https://vimeo.com/ondemand/genron20151209",
		"rawString": "2015年、井出明が歩いたダークツーリズムの足跡——『DARK tourism JAPAN Vol.2』刊行特別イベント\t井出明\t2015/12/09\thttps://vimeo.com/ondemand/genron20151209"
	},
	{
		"title": "【ニッポンの脳 #4】恒例時事対談・2015冬——迷走するオリンピックから考える日本の脳",
		"members": [
			"茂木健一郎",
			"東浩紀"
		],
		"date": "2015/12/01",
		"url": "https://vimeo.com/ondemand/genron20151201",
		"rawString": "【ニッポンの脳 #4】恒例時事対談・2015冬——迷走するオリンピックから考える日本の脳\t茂木健一郎、東浩紀\t2015/12/01\thttps://vimeo.com/ondemand/genron20151201"
	},
	{
		"title": "パラフィクションとしての筒井康隆——文学の未来、批評の未来",
		"members": [
			"筒井康隆",
			"東浩紀"
		],
		"date": "2015/11/29",
		"url": "https://vimeo.com/ondemand/genron20151129",
		"rawString": "パラフィクションとしての筒井康隆——文学の未来、批評の未来\t筒井康隆、東浩紀\t2015/11/29\thttps://vimeo.com/ondemand/genron20151129"
	},
	{
		"title": "【さやわか式☆現代文化論 #22】ゲームの話・スプラトゥーンはイカように位置づけ可能か",
		"members": [
			"さやわか"
		],
		"date": "2015/11/28",
		"url": "https://vimeo.com/ondemand/genron20151128",
		"rawString": "【さやわか式☆現代文化論 #22】ゲームの話・スプラトゥーンはイカように位置づけ可能か\tさやわか\t2015/11/28\thttps://vimeo.com/ondemand/genron20151128"
	},
	{
		"title": "満洲国というユートピア——分離独立から考える日本のいま",
		"members": [
			"安藤礼二",
			"速水健朗"
		],
		"date": "2015/11/25",
		"url": "https://vimeo.com/ondemand/genron20151125",
		"rawString": "満洲国というユートピア——分離独立から考える日本のいま\t安藤礼二、速水健朗\t2015/11/25\thttps://vimeo.com/ondemand/genron20151125"
	},
	{
		"title": "【大森望のSF喫茶 #19】ディストピアの最新系——『ユートロニカのこちら側』ハヤカワSFコンテスト大賞受賞記念イベント",
		"members": [
			"大森望",
			"小川哲"
		],
		"date": "2015/11/24",
		"url": "https://vimeo.com/ondemand/genron20151124",
		"rawString": "【大森望のSF喫茶 #19】ディストピアの最新系——『ユートロニカのこちら側』ハヤカワSFコンテスト大賞受賞記念イベント\t大森望、小川哲\t2015/11/24\thttps://vimeo.com/ondemand/genron20151124"
	},
	{
		"title": "人文系の衰退は必然である（？）——「知」のこれからを考える",
		"members": [
			"大澤真幸",
			"宮台真司",
			"東浩紀",
			"斎藤哲也"
		],
		"date": "2015/11/18",
		"url": "https://vimeo.com/ondemand/genron20151118",
		"rawString": "人文系の衰退は必然である（？）——「知」のこれからを考える\t大澤真幸、宮台真司、東浩紀、斎藤哲也\t2015/11/18\thttps://vimeo.com/ondemand/genron20151118"
	},
	{
		"title": "【独立国論 #3】いまなぜ「独立国論」を語るのか",
		"members": [
			"速水健朗"
		],
		"date": "2015/11/05",
		"url": "https://vimeo.com/ondemand/genron20151105",
		"rawString": "【独立国論 #3】いまなぜ「独立国論」を語るのか\t速水健朗\t2015/11/05\thttps://vimeo.com/ondemand/genron20151105"
	},
	{
		"title": "『戦争する国の道徳』刊行記念トークイベント",
		"members": [
			"小林よしのり",
			"宮台真司",
			"東浩紀"
		],
		"date": "2015/11/04",
		"url": "https://vimeo.com/ondemand/genron20151104",
		"rawString": "『戦争する国の道徳』刊行記念トークイベント\t小林よしのり、宮台真司、東浩紀\t2015/11/04\thttps://vimeo.com/ondemand/genron20151104"
	},
	{
		"title": "【独立国論 #2】革命とエンタメ。そして、なんとなく堤幸彦論。",
		"members": [
			"速水健朗"
		],
		"date": "2015/10/29",
		"url": "https://vimeo.com/ondemand/genron20151029",
		"rawString": "【独立国論 #2】革命とエンタメ。そして、なんとなく堤幸彦論。\t速水健朗\t2015/10/29\thttps://vimeo.com/ondemand/genron20151029"
	},
	{
		"title": "慰霊から建築を考える——宗教、忘却、オリンピック",
		"members": [
			"五十嵐太郎",
			"津田大介",
			"東浩紀"
		],
		"date": "2015/10/28",
		"url": "https://vimeo.com/ondemand/genron20151028",
		"rawString": "慰霊から建築を考える——宗教、忘却、オリンピック\t五十嵐太郎、津田大介、東浩紀\t2015/10/28\thttps://vimeo.com/ondemand/genron20151028"
	},
	{
		"title": "【大森望のSF喫茶 #18】テクノロジーと文学のゆくえ——小説をプログラミングする",
		"members": [
			"円城塔",
			"大森望",
			"東浩紀"
		],
		"date": "2015/10/24",
		"url": "https://vimeo.com/ondemand/genron20151024",
		"rawString": "【大森望のSF喫茶 #18】テクノロジーと文学のゆくえ——小説をプログラミングする\t円城塔、大森望、東浩紀\t2015/10/24\thttps://vimeo.com/ondemand/genron20151024"
	},
	{
		"title": "【さやわか式☆現代文化論 #21】2015年のアニメをそろそろまとめてみないか",
		"members": [
			"さやわか",
			"村上裕一",
			"坂上秋成",
			"東浩紀"
		],
		"date": "2015/10/23",
		"url": "https://vimeo.com/ondemand/genron20151023",
		"rawString": "【さやわか式☆現代文化論 #21】2015年のアニメをそろそろまとめてみないか\tさやわか、村上裕一、坂上秋成、東浩紀\t2015/10/23\thttps://vimeo.com/ondemand/genron20151023"
	},
	{
		"title": "「死生観光」入門――『怒りの日』と七墓を巡って",
		"members": [
			"岸井大輔",
			"黒瀬陽平",
			"陸奥賢"
		],
		"date": "2015/10/21",
		"url": "https://vimeo.com/ondemand/genron20151021",
		"rawString": "「死生観光」入門――『怒りの日』と七墓を巡って\t岸井大輔、黒瀬陽平、陸奥賢\t2015/10/21\thttps://vimeo.com/ondemand/genron20151021"
	},
	{
		"title": "人工知能はどこまで社会を変えるのか",
		"members": [
			"松尾豊",
			"東浩紀"
		],
		"date": "2015/10/20",
		"url": "https://vimeo.com/ondemand/genron20151020",
		"rawString": "人工知能はどこまで社会を変えるのか\t松尾豊、東浩紀\t2015/10/20\thttps://vimeo.com/ondemand/genron20151020"
	},
	{
		"title": "政界再編第2章——安保法案、都構想、落選運動",
		"members": [
			"柿沢未途",
			"竹田圭吾",
			"西田亮介"
		],
		"date": "2015/10/14",
		"url": "https://vimeo.com/ondemand/genron20151014",
		"rawString": "政界再編第2章——安保法案、都構想、落選運動\t柿沢未途、竹田圭吾、西田亮介\t2015/10/14\thttps://vimeo.com/ondemand/genron20151014"
	},
	{
		"title": "【ショッピングモールから考える #5】空想地図から都市を見る",
		"members": [
			"石川初",
			"今和泉隆行",
			"大山顕",
			"東浩紀"
		],
		"date": "2015/10/02",
		"url": "https://vimeo.com/ondemand/genron20151002",
		"rawString": "【ショッピングモールから考える #5】空想地図から都市を見る\t石川初、今和泉隆行、大山顕、東浩紀\t2015/10/02\thttps://vimeo.com/ondemand/genron20151002"
	},
	{
		"title": "認知症と新たなアプローチ——パターン・ランゲージを応用する",
		"members": [
			"井庭崇",
			"斎藤環"
		],
		"date": "2015/10/01",
		"url": "https://vimeo.com/ondemand/genron20151001",
		"rawString": "認知症と新たなアプローチ——パターン・ランゲージを応用する\t井庭崇、斎藤環\t2015/10/01\thttps://vimeo.com/ondemand/genron20151001"
	},
	{
		"title": "謎の独立国家ソマリランドと戦国南部ソマリア——辺境はSFよりも奇なり！",
		"members": [
			"高野秀行",
			"海猫沢めろん"
		],
		"date": "2015/09/30",
		"url": "https://vimeo.com/ondemand/genron20150930",
		"rawString": "謎の独立国家ソマリランドと戦国南部ソマリア——辺境はSFよりも奇なり！\t高野秀行、海猫沢めろん\t2015/09/30\thttps://vimeo.com/ondemand/genron20150930"
	},
	{
		"title": "演劇は〈現代の寓話〉を語れるか——範宙遊泳のフィクションと身体",
		"members": [
			"山本卓卓",
			"黒瀬陽平",
			"さやわか"
		],
		"date": "2015/09/25",
		"url": "https://vimeo.com/ondemand/genron20150925",
		"rawString": "演劇は〈現代の寓話〉を語れるか——範宙遊泳のフィクションと身体\t山本卓卓、黒瀬陽平、さやわか\t2015/09/25\thttps://vimeo.com/ondemand/genron20150925"
	},
	{
		"title": "1995/2015——いま人文知は必要か",
		"members": [
			"鈴木謙介",
			"東浩紀"
		],
		"date": "2015/09/19",
		"url": "https://vimeo.com/ondemand/genron20150919",
		"rawString": "1995/2015——いま人文知は必要か\t鈴木謙介、東浩紀\t2015/09/19\thttps://vimeo.com/ondemand/genron20150919"
	},
	{
		"title": "「映画的」であるとはどのようなことか？——見世物から『マッドマックス』へ",
		"members": [
			"平倉圭",
			"細馬宏通",
			"畠山宗明"
		],
		"date": "2015/09/18",
		"url": "https://vimeo.com/ondemand/genron20150918",
		"rawString": "「映画的」であるとはどのようなことか？——見世物から『マッドマックス』へ\t平倉圭、細馬宏通、畠山宗明\t2015/09/18\thttps://vimeo.com/ondemand/genron20150918"
	},
	{
		"title": "【独立国論 #1】失敗した人工国家満州国の理想とカルチャー——ひょっこりひょうたん島からジオン公国まで、去来する満州の影",
		"members": [
			"速水健朗"
		],
		"date": "2015/09/17",
		"url": "https://vimeo.com/ondemand/genron20150917",
		"rawString": "【独立国論 #1】失敗した人工国家満州国の理想とカルチャー——ひょっこりひょうたん島からジオン公国まで、去来する満州の影\t速水健朗\t2015/09/17\thttps://vimeo.com/ondemand/genron20150917"
	},
	{
		"title": "「日本のウェブはいまも奇妙なのか？——『アーキテクチャの生態系』から見る、情報社会論の現在」",
		"members": [
			"佐々木俊尚",
			"濱野智史"
		],
		"date": "2015/09/16",
		"url": "https://vimeo.com/ondemand/genron20150916",
		"rawString": "「日本のウェブはいまも奇妙なのか？——『アーキテクチャの生態系』から見る、情報社会論の現在」\t佐々木俊尚、濱野智史\t2015/09/16\thttps://vimeo.com/ondemand/genron20150916"
	},
	{
		"title": "ニッポンの展望2015・秋の陣――安保法案、新国立競技場、沖縄基地問題……混迷する世相を一刀両断！",
		"members": [
			"宮台真司",
			"東浩紀"
		],
		"date": "2015/09/09",
		"url": "https://vimeo.com/ondemand/genron20150909",
		"rawString": "ニッポンの展望2015・秋の陣――安保法案、新国立競技場、沖縄基地問題……混迷する世相を一刀両断！\t宮台真司、東浩紀\t2015/09/09\thttps://vimeo.com/ondemand/genron20150909"
	},
	{
		"title": "【さやわか式☆現代文化論 #20】描きたい人のための漫画術",
		"members": [
			"さやわか",
			"今井哲也",
			"ふみふみこ"
		],
		"date": "2015/08/28",
		"url": "https://vimeo.com/ondemand/genron20150828",
		"rawString": "【さやわか式☆現代文化論 #20】描きたい人のための漫画術\tさやわか、今井哲也、ふみふみこ\t2015/08/28\thttps://vimeo.com/ondemand/genron20150828"
	},
	{
		"title": "【愛国コンテンツの未来学 #4】政治と芸術に正しい関係は存在するか？——『ふしぎな君が代』（幻冬舎新書）刊行記念",
		"members": [
			"辻田真佐憲",
			"鈴木邦男"
		],
		"date": "2015/08/26",
		"url": "https://vimeo.com/ondemand/genron20150826",
		"rawString": "【愛国コンテンツの未来学 #4】政治と芸術に正しい関係は存在するか？——『ふしぎな君が代』（幻冬舎新書）刊行記念\t辻田真佐憲、鈴木邦男\t2015/08/26\thttps://vimeo.com/ondemand/genron20150826"
	},
	{
		"title": "デモは辺野古を止めるのか——『沖縄のことを教えてください』刊行記念鼎談",
		"members": [
			"津田大介",
			"初沢亜利",
			"東浩紀"
		],
		"date": "2015/08/19",
		"url": "https://vimeo.com/ondemand/genron20150819",
		"rawString": "デモは辺野古を止めるのか——『沖縄のことを教えてください』刊行記念鼎談\t津田大介、初沢亜利、東浩紀\t2015/08/19\thttps://vimeo.com/ondemand/genron20150819"
	},
	{
		"title": "新しい伝統をつくる——木ノ下歌舞伎の演劇と革新",
		"members": [
			"木ノ下裕一",
			"児玉竜一"
		],
		"date": "2015/08/14",
		"url": "https://vimeo.com/ondemand/genron20150814",
		"rawString": "新しい伝統をつくる——木ノ下歌舞伎の演劇と革新\t木ノ下裕一、児玉竜一\t2015/08/14\thttps://vimeo.com/ondemand/genron20150814"
	},
	{
		"title": "思想とデザイン——『アイデア』No.370刊行記念トークショー",
		"members": [
			"大澤聡",
			"加藤賢策",
			"山本貴光"
		],
		"date": "2015/08/07",
		"url": "https://vimeo.com/ondemand/genron20150807",
		"rawString": "思想とデザイン——『アイデア』No.370刊行記念トークショー\t大澤聡、加藤賢策、山本貴光\t2015/08/07\thttps://vimeo.com/ondemand/genron20150807"
	},
	{
		"title": "2010-2015 IT界10大ニュースを斬る！——ディープラーニング、2045年問題、シンギュラリティ……未来はもう始まっている!?",
		"members": [
			"清水亮",
			"東浩紀"
		],
		"date": "2015/08/06",
		"url": "https://vimeo.com/ondemand/genron20150806",
		"rawString": "2010-2015 IT界10大ニュースを斬る！——ディープラーニング、2045年問題、シンギュラリティ……未来はもう始まっている!?\t清水亮、東浩紀\t2015/08/06\thttps://vimeo.com/ondemand/genron20150806"
	},
	{
		"title": "ダークツーリズムと想像力——チェルノブイリ・廃墟の現在",
		"members": [
			"海猫沢めろん",
			"佐藤健寿",
			"徳久倫康"
		],
		"date": "2015/08/05",
		"url": "https://vimeo.com/ondemand/genron20150805",
		"rawString": "ダークツーリズムと想像力——チェルノブイリ・廃墟の現在\t海猫沢めろん、佐藤健寿、徳久倫康\t2015/08/05\thttps://vimeo.com/ondemand/genron20150805"
	},
	{
		"title": "レム・コールハース『S,M,L,XL』を読む——ちくま文庫版出版記念トークショー",
		"members": [
			"太田佳代子",
			"藤村龍至",
			"東浩紀"
		],
		"date": "2015/07/31",
		"url": "https://vimeo.com/ondemand/genron20150731",
		"rawString": "レム・コールハース『S,M,L,XL』を読む——ちくま文庫版出版記念トークショー\t太田佳代子、藤村龍至、東浩紀\t2015/07/31\thttps://vimeo.com/ondemand/genron20150731"
	},
	{
		"title": "【大森望のSF喫茶 #17】殊能将之ができるまで——『殊能将之 読書日記 2000-2009 The Reading Diary of Mercy Snow』刊行記念",
		"members": [
			"大森望",
			"磯達雄",
			"中村融",
			"柳下毅一郎"
		],
		"date": "2015/07/24",
		"url": "https://vimeo.com/ondemand/genron20150724",
		"rawString": "【大森望のSF喫茶 #17】殊能将之ができるまで——『殊能将之 読書日記 2000-2009 The Reading Diary of Mercy Snow』刊行記念\t大森望、磯達雄、中村融、柳下毅一郎\t2015/07/24\thttps://vimeo.com/ondemand/genron20150724"
	},
	{
		"title": "【批評はいま #2】いま、文芸批評がなすべきことは——渡部直己『小説技術論』刊行記念イベント",
		"members": [
			"大澤聡",
			"福嶋亮大",
			"渡部直己"
		],
		"date": "2015/07/18",
		"url": "https://vimeo.com/ondemand/genron20150718",
		"rawString": "【批評はいま #2】いま、文芸批評がなすべきことは——渡部直己『小説技術論』刊行記念イベント\t大澤聡、福嶋亮大、渡部直己\t2015/07/18\thttps://vimeo.com/ondemand/genron20150718"
	},
	{
		"title": "「論壇」はどこにあるのか",
		"members": [
			"高橋源一郎",
			"東浩紀"
		],
		"date": "2015/07/10",
		"url": "https://vimeo.com/ondemand/genron20150710",
		"rawString": "「論壇」はどこにあるのか\t高橋源一郎、東浩紀\t2015/07/10\thttps://vimeo.com/ondemand/genron20150710"
	},
	{
		"title": "ダークツーリズムと産業遺産——世界遺産登録から考える",
		"members": [
			"井出明"
		],
		"date": "2015/07/03",
		"url": "https://vimeo.com/ondemand/genron20150703",
		"rawString": "ダークツーリズムと産業遺産——世界遺産登録から考える\t井出明\t2015/07/03\thttps://vimeo.com/ondemand/genron20150703"
	},
	{
		"title": "【さやわか式☆現代文化論 #19】演劇と音楽のリズム——ままごと『わが星』再々演記念トークショー",
		"members": [
			"柴幸男",
			"三浦康嗣",
			"さやわか"
		],
		"date": "2015/06/30",
		"url": "https://vimeo.com/ondemand/genron20150630",
		"rawString": "【さやわか式☆現代文化論 #19】演劇と音楽のリズム——ままごと『わが星』再々演記念トークショー\t柴幸男、三浦康嗣、さやわか\t2015/06/30\thttps://vimeo.com/ondemand/genron20150630"
	},
	{
		"title": "広場にもどる建築——『広場』（淡交社）刊行記念トークショー",
		"members": [
			"隈研吾",
			"東浩紀"
		],
		"date": "2015/06/26",
		"url": "https://vimeo.com/ondemand/genron20150626",
		"rawString": "広場にもどる建築——『広場』（淡交社）刊行記念トークショー\t隈研吾、東浩紀\t2015/06/26\thttps://vimeo.com/ondemand/genron20150626"
	},
	{
		"title": "演じることと書くこと：前田司郎が見る、過去のない未来——エッセイ集・小説集・戯曲集連続刊行記念対談",
		"members": [
			"前田司郎",
			"九龍ジョー"
		],
		"date": "2015/06/24",
		"url": "https://vimeo.com/ondemand/genron20150624",
		"rawString": "演じることと書くこと：前田司郎が見る、過去のない未来——エッセイ集・小説集・戯曲集連続刊行記念対談\t前田司郎、九龍ジョー\t2015/06/24\thttps://vimeo.com/ondemand/genron20150624"
	},
	{
		"title": "【大森望のSF喫茶 #16】スタニスワフ・レムの実験室——『短篇ベスト10』＋ハヤカワ文庫版『ソラリス』刊行記念",
		"members": [
			"大森望",
			"沼野充義"
		],
		"date": "2015/06/23",
		"url": "https://vimeo.com/ondemand/genron20150623",
		"rawString": "【大森望のSF喫茶 #16】スタニスワフ・レムの実験室——『短篇ベスト10』＋ハヤカワ文庫版『ソラリス』刊行記念\t大森望、沼野充義\t2015/06/23\thttps://vimeo.com/ondemand/genron20150623"
	},
	{
		"title": "オタク批判はヘイトなのか——艦これ、サブカル、カウンター",
		"members": [
			"さやわか",
			"野間易通",
			"東浩紀",
			"川上量生"
		],
		"date": "2015/06/19",
		"url": "https://vimeo.com/ondemand/genron20150619",
		"rawString": "オタク批判はヘイトなのか——艦これ、サブカル、カウンター\tさやわか、野間易通、東浩紀、川上量生\t2015/06/19\thttps://vimeo.com/ondemand/genron20150619"
	},
	{
		"title": "【批評はいま #1】昭和90年代の批評と芸術の行方——ゲンロン友の会第6期キックオフイベント",
		"members": [
			"黒瀬陽平",
			"佐々木敦",
			"東浩紀"
		],
		"date": "2015/06/12",
		"url": "https://vimeo.com/ondemand/genron20150612",
		"rawString": "【批評はいま #1】昭和90年代の批評と芸術の行方——ゲンロン友の会第6期キックオフイベント\t黒瀬陽平、佐々木敦、東浩紀\t2015/06/12\thttps://vimeo.com/ondemand/genron20150612"
	},
	{
		"title": "日本的リベラリズムの夢——講談社文庫『一般意志2.0』刊行に向けて",
		"members": [
			"宇野重規",
			"東浩紀"
		],
		"date": "2015/06/10",
		"url": "https://vimeo.com/ondemand/genron20150610",
		"rawString": "日本的リベラリズムの夢——講談社文庫『一般意志2.0』刊行に向けて\t宇野重規、東浩紀\t2015/06/10\thttps://vimeo.com/ondemand/genron20150610"
	},
	{
		"title": "大阪都構想の可能性をいまこそ考える——なぜ橋下は敗れたのか",
		"members": [
			"西田亮介",
			"三浦瑠麗"
		],
		"date": "2015/06/05",
		"url": "https://vimeo.com/ondemand/genron20150605",
		"rawString": "大阪都構想の可能性をいまこそ考える——なぜ橋下は敗れたのか\t西田亮介、三浦瑠麗\t2015/06/05\thttps://vimeo.com/ondemand/genron20150605"
	},
	{
		"title": "右傾エンタメは日本を亡ぼすのか？——『文化亡国論』をめぐって",
		"members": [
			"笠井潔",
			"藤田直哉",
			"東浩紀"
		],
		"date": "2015/05/31",
		"url": "https://vimeo.com/ondemand/genron20150531",
		"rawString": "右傾エンタメは日本を亡ぼすのか？——『文化亡国論』をめぐって\t笠井潔、藤田直哉、東浩紀\t2015/05/31\thttps://vimeo.com/ondemand/genron20150531"
	},
	{
		"title": "〈広く告げる〉をやめた「広告」の新しい形 #2——変わるテクノロジーと変わらない人間の間で",
		"members": [
			"須田和博",
			"東浩紀",
			"廣田周作"
		],
		"date": "2015/05/29",
		"url": "https://vimeo.com/ondemand/genron20150529",
		"rawString": "〈広く告げる〉をやめた「広告」の新しい形 #2——変わるテクノロジーと変わらない人間の間で\t須田和博、東浩紀、廣田周作\t2015/05/29\thttps://vimeo.com/ondemand/genron20150529"
	},
	{
		"title": "人間的なITをつくるには？——＜電脳のレリギオ＞を求めて",
		"members": [
			"ドミニク・チェン",
			"濱野智史",
			"東浩紀"
		],
		"date": "2015/05/26",
		"url": "https://vimeo.com/ondemand/genron20150526",
		"rawString": "人間的なITをつくるには？——＜電脳のレリギオ＞を求めて\tドミニク・チェン、濱野智史、東浩紀\t2015/05/26\thttps://vimeo.com/ondemand/genron20150526"
	},
	{
		"title": "【大森望のSF喫茶 #15】西田藍のSFにゅうもん！ライブ版",
		"members": [
			"大森望",
			"西田藍"
		],
		"date": "2015/05/22",
		"url": "https://vimeo.com/ondemand/genron20150522",
		"rawString": "【大森望のSF喫茶 #15】西田藍のSFにゅうもん！ライブ版\t大森望、西田藍\t2015/05/22\thttps://vimeo.com/ondemand/genron20150522"
	},
	{
		"title": "【さやわか式☆現代文化論 #18】京都アニメーションの目",
		"members": [
			"さやわか"
		],
		"date": "2015/05/21",
		"url": "https://vimeo.com/ondemand/genron20150521",
		"rawString": "【さやわか式☆現代文化論 #18】京都アニメーションの目\tさやわか\t2015/05/21\thttps://vimeo.com/ondemand/genron20150521"
	},
	{
		"title": "18歳からの政治参加入門——インターネットと政治を考える",
		"members": [
			"石戸諭",
			"西田亮介"
		],
		"date": "2015/05/14",
		"url": "https://vimeo.com/ondemand/genron20150514",
		"rawString": "18歳からの政治参加入門——インターネットと政治を考える\t石戸諭、西田亮介\t2015/05/14\thttps://vimeo.com/ondemand/genron20150514"
	},
	{
		"title": "系外惑星から考える——太陽系は唯一の可能性か",
		"members": [
			"井田茂",
			"東浩紀"
		],
		"date": "2015/05/13",
		"url": "https://vimeo.com/ondemand/genron20150513",
		"rawString": "系外惑星から考える——太陽系は唯一の可能性か\t井田茂、東浩紀\t2015/05/13\thttps://vimeo.com/ondemand/genron20150513"
	},
	{
		"title": "「男」それは、いまここにある危機。——あなたの「男」は、こじれてる!? 男が無いことにしてる「生き方問題」を、徹底的に語ります。",
		"members": [
			"湯山玲子",
			"津田大介"
		],
		"date": "2015/05/08",
		"url": "https://vimeo.com/ondemand/genron20150508",
		"rawString": "「男」それは、いまここにある危機。——あなたの「男」は、こじれてる!? 男が無いことにしてる「生き方問題」を、徹底的に語ります。\t湯山玲子、津田大介\t2015/05/08\thttps://vimeo.com/ondemand/genron20150508"
	},
	{
		"title": "原発事故を表象する——映画『フタバから遠く離れて』関連トークショー",
		"members": [
			"舩橋淳",
			"東浩紀",
			"津田大介"
		],
		"date": "2015/05/02",
		"url": "https://vimeo.com/ondemand/genron20150502",
		"rawString": "原発事故を表象する——映画『フタバから遠く離れて』関連トークショー\t舩橋淳、東浩紀、津田大介\t2015/05/02\thttps://vimeo.com/ondemand/genron20150502"
	},
	{
		"title": "ストリート・アートの最前線——『アゲインスト・リテラシー——グラフィティ文化論』刊行記念トーク",
		"members": [
			"大山エンリコイサム",
			"黒瀬陽平"
		],
		"date": "2015/04/29",
		"url": "https://vimeo.com/ondemand/genron20150429",
		"rawString": "ストリート・アートの最前線——『アゲインスト・リテラシー——グラフィティ文化論』刊行記念トーク\t大山エンリコイサム、黒瀬陽平\t2015/04/29\thttps://vimeo.com/ondemand/genron20150429"
	},
	{
		"title": "全体主義とユートピア建築——『天体建築論 レオニドフとソ連邦の紙上建築時代』サントリー学芸賞受賞記念トークショー",
		"members": [
			"本田晃子",
			"上田洋子"
		],
		"date": "2015/04/28",
		"url": "https://vimeo.com/ondemand/genron20150428",
		"rawString": "全体主義とユートピア建築——『天体建築論 レオニドフとソ連邦の紙上建築時代』サントリー学芸賞受賞記念トークショー\t本田晃子、上田洋子\t2015/04/28\thttps://vimeo.com/ondemand/genron20150428"
	},
	{
		"title": "【さやわか式☆現代文化論 #17】fhánaと語る、アニソンの現在",
		"members": [
			"さやわか",
			"fhána"
		],
		"date": "2015/04/25",
		"url": "https://vimeo.com/ondemand/genron20150425",
		"rawString": "【さやわか式☆現代文化論 #17】fhánaと語る、アニソンの現在\tさやわか、fhána\t2015/04/25\thttps://vimeo.com/ondemand/genron20150425"
	},
	{
		"title": "運と確率の進化論——『理不尽な進化』をめぐって",
		"members": [
			"吉川浩満",
			"東浩紀"
		],
		"date": "2015/04/24",
		"url": "https://vimeo.com/ondemand/genron20150424",
		"rawString": "運と確率の進化論——『理不尽な進化』をめぐって\t吉川浩満、東浩紀\t2015/04/24\thttps://vimeo.com/ondemand/genron20150424"
	},
	{
		"title": "【大森望のSF喫茶 #14】人気作家が即興実演！ショートショートのつくり方",
		"members": [
			"大森望",
			"田丸雅智"
		],
		"date": "2015/04/23",
		"url": "https://vimeo.com/ondemand/genron20150423",
		"rawString": "【大森望のSF喫茶 #14】人気作家が即興実演！ショートショートのつくり方\t大森望、田丸雅智\t2015/04/23\thttps://vimeo.com/ondemand/genron20150423"
	},
	{
		"title": "批評の精神分析2015——ラカン、ヤンキー、ノーラン",
		"members": [
			"斎藤環",
			"東浩紀"
		],
		"date": "2015/04/22",
		"url": "https://vimeo.com/ondemand/genron20150422",
		"rawString": "批評の精神分析2015——ラカン、ヤンキー、ノーラン\t斎藤環、東浩紀\t2015/04/22\thttps://vimeo.com/ondemand/genron20150422"
	},
	{
		"title": "批評にゼロアカは必要だったのか？——批評再生塾キックオフイベント番外編",
		"members": [
			"坂上秋成",
			"村上裕一",
			"東浩紀"
		],
		"date": "2015/04/15",
		"url": "https://vimeo.com/ondemand/genron20150415",
		"rawString": "批評にゼロアカは必要だったのか？——批評再生塾キックオフイベント番外編\t坂上秋成、村上裕一、東浩紀\t2015/04/15\thttps://vimeo.com/ondemand/genron20150415"
	},
	{
		"title": "批評に近代は必要か——『批評メディア論』から読む『復興文化論』",
		"members": [
			"大澤聡",
			"福嶋亮大",
			"東浩紀"
		],
		"date": "2015/04/11",
		"url": "https://vimeo.com/ondemand/genron20150411",
		"rawString": "批評に近代は必要か——『批評メディア論』から読む『復興文化論』\t大澤聡、福嶋亮大、東浩紀\t2015/04/11\thttps://vimeo.com/ondemand/genron20150411"
	},
	{
		"title": "イスラム国から考える——なぜそれは見世物になるのか",
		"members": [
			"常岡浩介",
			"東浩紀"
		],
		"date": "2015/04/10",
		"url": "https://vimeo.com/ondemand/genron20150410",
		"rawString": "イスラム国から考える——なぜそれは見世物になるのか\t常岡浩介、東浩紀\t2015/04/10\thttps://vimeo.com/ondemand/genron20150410"
	},
	{
		"title": "『常磐線中心主義』刊行記念トークショー：線路はどこで途切れていたのか",
		"members": [
			"五十嵐泰正",
			"開沼博",
			"小松理虔",
			"東浩紀"
		],
		"date": "2015/04/08",
		"url": "https://vimeo.com/ondemand/genron20150408",
		"rawString": "『常磐線中心主義』刊行記念トークショー：線路はどこで途切れていたのか\t五十嵐泰正、開沼博、小松理虔、東浩紀\t2015/04/08\thttps://vimeo.com/ondemand/genron20150408"
	},
	{
		"title": "ゴダール、3D、そして運動——映画にとって「深さ」とはなにか？",
		"members": [
			"平倉圭",
			"細馬宏通",
			"畠山宗明"
		],
		"date": "2015/03/29",
		"url": "https://vimeo.com/ondemand/genron20150329",
		"rawString": "ゴダール、3D、そして運動——映画にとって「深さ」とはなにか？\t平倉圭、細馬宏通、畠山宗明\t2015/03/29\thttps://vimeo.com/ondemand/genron20150329"
	},
	{
		"title": "世界に仕掛ける新しい演劇——『完全避難マニュアル』から新プロジェクトへ:2014年ドイツ語圏最重要演劇入賞記念イベント",
		"members": [
			"高山明",
			"黒瀬陽平",
			"東浩紀"
		],
		"date": "2015/03/28",
		"url": "https://vimeo.com/ondemand/genron20150328",
		"rawString": "世界に仕掛ける新しい演劇——『完全避難マニュアル』から新プロジェクトへ:2014年ドイツ語圏最重要演劇入賞記念イベント\t高山明、黒瀬陽平、東浩紀\t2015/03/28\thttps://vimeo.com/ondemand/genron20150328"
	},
	{
		"title": "日本を変えるにはテロしかないのか？——沖縄の怒り、福島の怒り、政権の無関心",
		"members": [
			"小林よしのり",
			"宮台真司",
			"東浩紀"
		],
		"date": "2015/03/24",
		"url": "https://vimeo.com/ondemand/genron20150324",
		"rawString": "日本を変えるにはテロしかないのか？——沖縄の怒り、福島の怒り、政権の無関心\t小林よしのり、宮台真司、東浩紀\t2015/03/24\thttps://vimeo.com/ondemand/genron20150324"
	},
	{
		"title": "昭和90年代、批評は再起動する——スクール第2弾＜ゲンロン 佐々木敦 批評再生塾＞ついに始動！",
		"members": [
			"佐々木敦",
			"東浩紀"
		],
		"date": "2015/03/20",
		"url": "https://vimeo.com/ondemand/genron20150320",
		"rawString": "昭和90年代、批評は再起動する——スクール第2弾＜ゲンロン 佐々木敦 批評再生塾＞ついに始動！\t佐々木敦、東浩紀\t2015/03/20\thttps://vimeo.com/ondemand/genron20150320"
	},
	{
		"title": "【ニッポンの脳 #3】またまた帰ってきた茂木健一郎——トラブル続出、神回続きの迷コンビがイスラム国、ピケティ、東京五輪などあらゆる話題を一刀両断！",
		"members": [
			"茂木健一郎",
			"東浩紀"
		],
		"date": "2015/03/04",
		"url": "https://vimeo.com/ondemand/genron20150304",
		"rawString": "【ニッポンの脳 #3】またまた帰ってきた茂木健一郎——トラブル続出、神回続きの迷コンビがイスラム国、ピケティ、東京五輪などあらゆる話題を一刀両断！\t茂木健一郎、東浩紀\t2015/03/04\thttps://vimeo.com/ondemand/genron20150304"
	},
	{
		"title": "旅から始まる思想と仕事——「途上国」のものづくりが資本主義を変える",
		"members": [
			"山崎大祐",
			"東浩紀"
		],
		"date": "2015/02/27",
		"url": "https://vimeo.com/ondemand/genron20150227",
		"rawString": "旅から始まる思想と仕事——「途上国」のものづくりが資本主義を変える\t山崎大祐、東浩紀\t2015/02/27\thttps://vimeo.com/ondemand/genron20150227"
	},
	{
		"title": "パリ風刺画新聞襲撃、イスラム国、そして、私戦予備陰謀——どこへゆく人類文明とニッポン？：『イスラム国とは何か』刊行記念トークショー",
		"members": [
			"常岡浩介",
			"津田大介",
			"東浩紀"
		],
		"date": "2015/02/25",
		"url": "https://vimeo.com/ondemand/genron20150225",
		"rawString": "パリ風刺画新聞襲撃、イスラム国、そして、私戦予備陰謀——どこへゆく人類文明とニッポン？：『イスラム国とは何か』刊行記念トークショー\t常岡浩介、津田大介、東浩紀\t2015/02/25\thttps://vimeo.com/ondemand/genron20150225"
	},
	{
		"title": "デリダ研究の最前線——「生・死」の哲学にむけて",
		"members": [
			"宮﨑裕助",
			"東浩紀"
		],
		"date": "2015/02/24",
		"url": "https://vimeo.com/ondemand/genron20150224",
		"rawString": "デリダ研究の最前線——「生・死」の哲学にむけて\t宮﨑裕助、東浩紀\t2015/02/24\thttps://vimeo.com/ondemand/genron20150224"
	},
	{
		"title": "【さやわか式☆現代文化論 #15】AKB商法は音楽を救ったのか——『僕たちとアイドルの時代』刊行記念",
		"members": [
			"さやわか",
			"中森明夫"
		],
		"date": "2015/02/21",
		"url": "https://vimeo.com/ondemand/genron20150221",
		"rawString": "【さやわか式☆現代文化論 #15】AKB商法は音楽を救ったのか——『僕たちとアイドルの時代』刊行記念\tさやわか、中森明夫\t2015/02/21\thttps://vimeo.com/ondemand/genron20150221"
	},
	{
		"title": "『救出——3.11気仙沼 公民館に取り残された446人』刊行記念イベント",
		"members": [
			"猪瀬直樹",
			"東浩紀"
		],
		"date": "2015/02/18",
		"url": "https://vimeo.com/ondemand/genron20150218",
		"rawString": "『救出——3.11気仙沼 公民館に取り残された446人』刊行記念イベント\t猪瀬直樹、東浩紀\t2015/02/18\thttps://vimeo.com/ondemand/genron20150218"
	},
	{
		"title": "日本インテリアデザイン史とその後",
		"members": [
			"浅子佳英",
			"今村創平",
			"鈴木紀慶"
		],
		"date": "2015/02/12",
		"url": "https://vimeo.com/ondemand/genron20150212",
		"rawString": "日本インテリアデザイン史とその後\t浅子佳英、今村創平、鈴木紀慶\t2015/02/12\thttps://vimeo.com/ondemand/genron20150212"
	},
	{
		"title": "【福島はいま #4】復興のためのナショナリズム——福島から考える日本の未来",
		"members": [
			"先崎彰容",
			"東浩紀"
		],
		"date": "2015/02/11",
		"url": "https://vimeo.com/ondemand/genron20150211",
		"rawString": "【福島はいま #4】復興のためのナショナリズム——福島から考える日本の未来\t先崎彰容、東浩紀\t2015/02/11\thttps://vimeo.com/ondemand/genron20150211"
	},
	{
		"title": "ゲンロンから遡る批評の歴史《2015→1930》——大澤聡『批評メディア論』刊行記念",
		"members": [
			"大澤聡",
			"東浩紀"
		],
		"date": "2015/02/06",
		"url": "https://vimeo.com/ondemand/genron20150206",
		"rawString": "ゲンロンから遡る批評の歴史《2015→1930》——大澤聡『批評メディア論』刊行記念\t大澤聡、東浩紀\t2015/02/06\thttps://vimeo.com/ondemand/genron20150206"
	},
	{
		"title": "J-POP IS OVER？——佐々木敦『ニッポンの音楽』刊行記念イベント",
		"members": [
			"佐々木敦",
			"柴那典",
			"南波一海"
		],
		"date": "2015/02/04",
		"url": "https://vimeo.com/ondemand/genron20150204",
		"rawString": "J-POP IS OVER？——佐々木敦『ニッポンの音楽』刊行記念イベント\t佐々木敦、柴那典、南波一海\t2015/02/04\thttps://vimeo.com/ondemand/genron20150204"
	},
	{
		"title": "【ショッピングモールから考える #4】庭・オアシス・ユートピア",
		"members": [
			"石川初",
			"大山顕",
			"東浩紀"
		],
		"date": "2015/01/31",
		"url": "https://vimeo.com/ondemand/genron20150131",
		"rawString": "【ショッピングモールから考える #4】庭・オアシス・ユートピア\t石川初、大山顕、東浩紀\t2015/01/31\thttps://vimeo.com/ondemand/genron20150131"
	},
	{
		"title": "【大森望のSF喫茶 #12】ハヤカワ文庫SF総解説！ その歴史とヴィジョン",
		"members": [
			"大森望",
			"森優",
			"込山博実"
		],
		"date": "2015/01/29",
		"url": "https://vimeo.com/ondemand/genron20150129",
		"rawString": "【大森望のSF喫茶 #12】ハヤカワ文庫SF総解説！ その歴史とヴィジョン\t大森望、森優、込山博実\t2015/01/29\thttps://vimeo.com/ondemand/genron20150129"
	},
	{
		"title": "〈近代〉以後としての〈現在〉とは？——経済・政治・文化そしてコンテンツ",
		"members": [
			"市川真人",
			"大澤真幸"
		],
		"date": "2015/01/28",
		"url": "https://vimeo.com/ondemand/genron20150128",
		"rawString": "〈近代〉以後としての〈現在〉とは？——経済・政治・文化そしてコンテンツ\t市川真人、大澤真幸\t2015/01/28\thttps://vimeo.com/ondemand/genron20150128"
	},
	{
		"title": "折口信夫の愛と暴力——『折口信夫』刊行記念トークショー",
		"members": [
			"安藤礼二",
			"赤坂真理"
		],
		"date": "2015/01/27",
		"url": "https://vimeo.com/ondemand/genron20150127",
		"rawString": "折口信夫の愛と暴力——『折口信夫』刊行記念トークショー\t安藤礼二、赤坂真理\t2015/01/27\thttps://vimeo.com/ondemand/genron20150127"
	},
	{
		"title": "無敵の文理融合コンビが総選挙からニコキャスまで一刀両断！——ゲンロンカフェ2周年記念：五反田IT漫談2015",
		"members": [
			"清水亮",
			"東浩紀"
		],
		"date": "2015/01/21",
		"url": "https://vimeo.com/ondemand/genron20150121",
		"rawString": "無敵の文理融合コンビが総選挙からニコキャスまで一刀両断！——ゲンロンカフェ2周年記念：五反田IT漫談2015\t清水亮、東浩紀\t2015/01/21\thttps://vimeo.com/ondemand/genron20150121"
	},
	{
		"title": "現代思想の使命——1989/1995/2011",
		"members": [
			"浅田彰",
			"中沢新一",
			"東浩紀"
		],
		"date": "2015/01/17",
		"url": "https://vimeo.com/ondemand/genron20150117",
		"rawString": "現代思想の使命——1989/1995/2011\t浅田彰、中沢新一、東浩紀\t2015/01/17\thttps://vimeo.com/ondemand/genron20150117"
	},
	{
		"title": "日本にリークサイトが必要な理由",
		"members": [
			"八田真行",
			"塚越健司"
		],
		"date": "2014/12/26",
		"url": "https://vimeo.com/ondemand/genron20141226",
		"rawString": "日本にリークサイトが必要な理由\t八田真行、塚越健司\t2014/12/26\thttps://vimeo.com/ondemand/genron20141226"
	},
	{
		"title": "ニッポンの展望2015——2014年総括＆2015年大予言！",
		"members": [
			"宮台真司",
			"東浩紀",
			"津田大介"
		],
		"date": "2014/12/25",
		"url": "https://vimeo.com/ondemand/genron20141225",
		"rawString": "ニッポンの展望2015——2014年総括＆2015年大予言！\t宮台真司、東浩紀、津田大介\t2014/12/25\thttps://vimeo.com/ondemand/genron20141225"
	},
	{
		"title": "反ヘイトの論理と憐れみの倫理",
		"members": [
			"野間易通",
			"尹雄大",
			"東浩紀"
		],
		"date": "2014/12/20",
		"url": "https://vimeo.com/ondemand/genron20141220",
		"rawString": "反ヘイトの論理と憐れみの倫理\t野間易通、尹雄大、東浩紀\t2014/12/20\thttps://vimeo.com/ondemand/genron20141220"
	},
	{
		"title": "香港雨傘運動から日本の民主主義を見る",
		"members": [
			"小熊英二",
			"張彧暋"
		],
		"date": "2014/12/18",
		"url": "https://vimeo.com/ondemand/genron20141218",
		"rawString": "香港雨傘運動から日本の民主主義を見る\t小熊英二、張彧暋\t2014/12/18\thttps://vimeo.com/ondemand/genron20141218"
	},
	{
		"title": "【大森望のSF喫茶 #11】いま＜SFを書く＞とは？",
		"members": [
			"大森望",
			"柴田勝家",
			"神々廻楽市",
			"高山羽根子"
		],
		"date": "2014/12/16",
		"url": "https://vimeo.com/ondemand/genron20141216",
		"rawString": "【大森望のSF喫茶 #11】いま＜SFを書く＞とは？\t大森望、柴田勝家、神々廻楽市、高山羽根子\t2014/12/16\thttps://vimeo.com/ondemand/genron20141216"
	},
	{
		"title": "LGBTナイト——変貌する＜カミングアウト＞",
		"members": [
			"田亀源五郎",
			"クリス・ローウィー"
		],
		"date": "2014/12/12",
		"url": "https://vimeo.com/ondemand/genron20141212",
		"rawString": "LGBTナイト——変貌する＜カミングアウト＞\t田亀源五郎、クリス・ローウィー\t2014/12/12\thttps://vimeo.com/ondemand/genron20141212"
	},
	{
		"title": "日本現代美術に＜正史＞はあるのか？——2010年代のアートと循環史観：『現代美術史日本篇 1945-2014』（改訂版）刊行記念イベント！",
		"members": [
			"中ザワヒデキ",
			"黒瀬陽平"
		],
		"date": "2014/12/06",
		"url": "https://vimeo.com/ondemand/genron20141206",
		"rawString": "日本現代美術に＜正史＞はあるのか？——2010年代のアートと循環史観：『現代美術史日本篇 1945-2014』（改訂版）刊行記念イベント！\t中ザワヒデキ、黒瀬陽平\t2014/12/06\thttps://vimeo.com/ondemand/genron20141206"
	},
	{
		"title": "イスラーム国とはなにか？——カリフ制再興運動、イスラーム法、そしてアサド政権19万人の虐殺",
		"members": [
			"池内恵",
			"常岡浩介"
		],
		"date": "2014/12/03",
		"url": "https://vimeo.com/ondemand/genron20141203",
		"rawString": "イスラーム国とはなにか？——カリフ制再興運動、イスラーム法、そしてアサド政権19万人の虐殺\t池内恵、常岡浩介\t2014/12/03\thttps://vimeo.com/ondemand/genron20141203"
	},
	{
		"title": "2014年、井出明が歩いたダークツーリズムの足跡——隠れキリシタンからアウシュビッツまで",
		"members": [
			"井出明"
		],
		"date": "2014/11/30",
		"url": "https://vimeo.com/ondemand/genron20141130",
		"rawString": "2014年、井出明が歩いたダークツーリズムの足跡——隠れキリシタンからアウシュビッツまで\t井出明\t2014/11/30\thttps://vimeo.com/ondemand/genron20141130"
	},
	{
		"title": "『さようならと言ってなかった』刊行記念トークイベント",
		"members": [
			"猪瀬直樹",
			"東浩紀"
		],
		"date": "2014/11/29",
		"url": "https://vimeo.com/ondemand/genron20141129",
		"rawString": "『さようならと言ってなかった』刊行記念トークイベント\t猪瀬直樹、東浩紀\t2014/11/29\thttps://vimeo.com/ondemand/genron20141129"
	},
	{
		"title": "【大森望のSF喫茶 #10】パンツァークラウンからPSYCHO-PASSへ——ポストサイバーパンク、現在進行形",
		"members": [
			"大森望",
			"吉上亮"
		],
		"date": "2014/11/27",
		"url": "https://vimeo.com/ondemand/genron20141127",
		"rawString": "【大森望のSF喫茶 #10】パンツァークラウンからPSYCHO-PASSへ——ポストサイバーパンク、現在進行形\t大森望、吉上亮\t2014/11/27\thttps://vimeo.com/ondemand/genron20141127"
	},
	{
		"title": "【さやわか式☆現代文化論 #12】ナタリーさん、悪質バイラルメディアどう思います？",
		"members": [
			"さやわか",
			"大山卓也"
		],
		"date": "2014/11/23",
		"url": "https://vimeo.com/ondemand/genron20141123",
		"rawString": "【さやわか式☆現代文化論 #12】ナタリーさん、悪質バイラルメディアどう思います？\tさやわか、大山卓也\t2014/11/23\thttps://vimeo.com/ondemand/genron20141123"
	},
	{
		"title": "カオス*ラウンジが語る、もっとも新しい日本現代美術史",
		"members": [
			"梅沢和木",
			"黒瀬陽平",
			"藤城噓"
		],
		"date": "2014/11/22",
		"url": "https://vimeo.com/ondemand/genron20141122",
		"rawString": "カオス*ラウンジが語る、もっとも新しい日本現代美術史\t梅沢和木、黒瀬陽平、藤城噓\t2014/11/22\thttps://vimeo.com/ondemand/genron20141122"
	},
	{
		"title": "医師に人権はあるのか——医師法21条、女子医大事件、ヒポクラテスの誓い",
		"members": [
			"佐藤一樹",
			"大脇幸志郎"
		],
		"date": "2014/11/21",
		"url": "https://vimeo.com/ondemand/genron20141121",
		"rawString": "医師に人権はあるのか——医師法21条、女子医大事件、ヒポクラテスの誓い\t佐藤一樹、大脇幸志郎\t2014/11/21\thttps://vimeo.com/ondemand/genron20141121"
	},
	{
		"title": "美術からマンガを見る／マンガから美術を見る——『マンガを「見る」という体験』刊行記念対談",
		"members": [
			"伊藤剛",
			"加治屋健司"
		],
		"date": "2014/11/14",
		"url": "https://vimeo.com/ondemand/genron20141114",
		"rawString": "美術からマンガを見る／マンガから美術を見る——『マンガを「見る」という体験』刊行記念対談\t伊藤剛、加治屋健司\t2014/11/14\thttps://vimeo.com/ondemand/genron20141114"
	},
	{
		"title": "東アジアでデモは可能か——香港デモ最新レポ",
		"members": [
			"五野井郁夫",
			"福嶋亮大",
			"東浩紀"
		],
		"date": "2014/11/12",
		"url": "https://vimeo.com/ondemand/genron20141112",
		"rawString": "東アジアでデモは可能か——香港デモ最新レポ\t五野井郁夫、福嶋亮大、東浩紀\t2014/11/12\thttps://vimeo.com/ondemand/genron20141112"
	},
	{
		"title": "【『存在論的、郵便的』を読む #5】『存在論的、郵便的』と『弱いつながり』の弱いつながり",
		"members": [
			"東浩紀"
		],
		"date": "2014/11/08",
		"url": "https://vimeo.com/ondemand/genron20141108",
		"rawString": "【『存在論的、郵便的』を読む #5】『存在論的、郵便的』と『弱いつながり』の弱いつながり\t東浩紀\t2014/11/08\thttps://vimeo.com/ondemand/genron20141108"
	},
	{
		"title": "アイドル論の臨界点～アイドル×日本×経済——境真良『アイドル国富論』刊行記念イベント",
		"members": [
			"斎藤環",
			"境真良",
			"松井孝治"
		],
		"date": "2014/11/07",
		"url": "https://vimeo.com/ondemand/genron20141107",
		"rawString": "アイドル論の臨界点～アイドル×日本×経済——境真良『アイドル国富論』刊行記念イベント\t斎藤環、境真良、松井孝治\t2014/11/07\thttps://vimeo.com/ondemand/genron20141107"
	},
	{
		"title": "日本は「芸術立国」になれるか——文化から社会を変える",
		"members": [
			"平田オリザ",
			"東浩紀",
			"内野儀"
		],
		"date": "2014/11/03",
		"url": "https://vimeo.com/ondemand/genron20141103",
		"rawString": "日本は「芸術立国」になれるか——文化から社会を変える\t平田オリザ、東浩紀、内野儀\t2014/11/03\thttps://vimeo.com/ondemand/genron20141103"
	},
	{
		"title": "【福島はいま #3】南相馬サーフツーリズムの可能性",
		"members": [
			"奥本英樹",
			"西田亮介",
			"東浩紀"
		],
		"date": "2014/10/24",
		"url": "https://vimeo.com/ondemand/genron20141024",
		"rawString": "【福島はいま #3】南相馬サーフツーリズムの可能性\t奥本英樹、西田亮介、東浩紀\t2014/10/24\thttps://vimeo.com/ondemand/genron20141024"
	},
	{
		"title": "【大森望のSF喫茶 #9】《NOVA+》発刊記念トークイベント：日本ＳＦ最前線",
		"members": [
			"大森望",
			"月村了衛",
			"長谷敏司",
			"宮内悠介"
		],
		"date": "2014/10/23",
		"url": "https://vimeo.com/ondemand/genron20141023",
		"rawString": "【大森望のSF喫茶 #9】《NOVA+》発刊記念トークイベント：日本ＳＦ最前線\t大森望、月村了衛、長谷敏司、宮内悠介\t2014/10/23\thttps://vimeo.com/ondemand/genron20141023"
	},
	{
		"title": "【さやわか式☆現代文化論 #11】インターネットは日本化している",
		"members": [
			"さやわか",
			"ばるぼら"
		],
		"date": "2014/10/19",
		"url": "https://vimeo.com/ondemand/genron20141019",
		"rawString": "【さやわか式☆現代文化論 #11】インターネットは日本化している\tさやわか、ばるぼら\t2014/10/19\thttps://vimeo.com/ondemand/genron20141019"
	},
	{
		"title": "デザインによるユートピアとポスト・ユートピア——ロシア・アヴァンギャルドから現在へ",
		"members": [
			"加藤賢策",
			"上田洋子"
		],
		"date": "2014/10/15",
		"url": "https://vimeo.com/ondemand/genron20141015",
		"rawString": "デザインによるユートピアとポスト・ユートピア——ロシア・アヴァンギャルドから現在へ\t加藤賢策、上田洋子\t2014/10/15\thttps://vimeo.com/ondemand/genron20141015"
	},
	{
		"title": "工学の国で意匠の可能性を問う——藤村龍至『批判的工学主義の建築』『プロトタイピング——模型とつぶやき』刊行記念トークショー",
		"members": [
			"倉方俊輔",
			"豊川斎赫",
			"藤村龍至"
		],
		"date": "2014/10/13",
		"url": "https://vimeo.com/ondemand/genron20141013",
		"rawString": "工学の国で意匠の可能性を問う——藤村龍至『批判的工学主義の建築』『プロトタイピング——模型とつぶやき』刊行記念トークショー\t倉方俊輔、豊川斎赫、藤村龍至\t2014/10/13\thttps://vimeo.com/ondemand/genron20141013"
	},
	{
		"title": "【ショッピングモールから考える #3】バックヤード・テーマパーク・未来都市",
		"members": [
			"大山顕",
			"東浩紀"
		],
		"date": "2014/10/08",
		"url": "https://vimeo.com/ondemand/genron20141008",
		"rawString": "【ショッピングモールから考える #3】バックヤード・テーマパーク・未来都市\t大山顕、東浩紀\t2014/10/08\thttps://vimeo.com/ondemand/genron20141008"
	},
	{
		"title": "司馬遼太郎を乗り越えるには——新城カズマ『島津戦記』刊行記念インタビュー",
		"members": [
			"新城カズマ",
			"海猫沢めろん"
		],
		"date": "2014/10/05",
		"url": "https://vimeo.com/ondemand/genron20141005",
		"rawString": "司馬遼太郎を乗り越えるには——新城カズマ『島津戦記』刊行記念インタビュー\t新城カズマ、海猫沢めろん\t2014/10/05\thttps://vimeo.com/ondemand/genron20141005"
	},
	{
		"title": "謎解き「いとうせいこう」——ラップから『想像ラジオ』",
		"members": [
			"市川真人",
			"いとうせいこう"
		],
		"date": "2014/10/03",
		"url": "https://vimeo.com/ondemand/genron20141003",
		"rawString": "謎解き「いとうせいこう」——ラップから『想像ラジオ』\t市川真人、いとうせいこう\t2014/10/03\thttps://vimeo.com/ondemand/genron20141003"
	},
	{
		"title": "テン年代カルチャーの行方——＜ゲーム的リアリズム＞から＜パラフィクション＞へ？",
		"members": [
			"佐々木敦",
			"東浩紀"
		],
		"date": "2014/10/02",
		"url": "https://vimeo.com/ondemand/genron20141002",
		"rawString": "テン年代カルチャーの行方——＜ゲーム的リアリズム＞から＜パラフィクション＞へ？\t佐々木敦、東浩紀\t2014/10/02\thttps://vimeo.com/ondemand/genron20141002"
	},
	{
		"title": "【物語と観客の日本文明論——『復興文化論』の先へ #3】旅・日本思想・アヴァンギャルド",
		"members": [
			"福嶋亮大",
			"東浩紀"
		],
		"date": "2014/09/26",
		"url": "https://vimeo.com/ondemand/genron20140926",
		"rawString": "【物語と観客の日本文明論——『復興文化論』の先へ #3】旅・日本思想・アヴァンギャルド\t福嶋亮大、東浩紀\t2014/09/26\thttps://vimeo.com/ondemand/genron20140926"
	},
	{
		"title": "安倍政権は止まるのか——ウェブとデモで【これから】【本当に】政治を変えるには",
		"members": [
			"西田亮介",
			"三宅洋平"
		],
		"date": "2014/09/24",
		"url": "https://vimeo.com/ondemand/genron20140924",
		"rawString": "安倍政権は止まるのか——ウェブとデモで【これから】【本当に】政治を変えるには\t西田亮介、三宅洋平\t2014/09/24\thttps://vimeo.com/ondemand/genron20140924"
	},
	{
		"title": "宝塚歌劇が作る新しい日本文化——レジャー・女性・ユートピア",
		"members": [
			"川崎賢子",
			"上田洋子"
		],
		"date": "2014/09/23",
		"url": "https://vimeo.com/ondemand/genron20140923",
		"rawString": "宝塚歌劇が作る新しい日本文化——レジャー・女性・ユートピア\t川崎賢子、上田洋子\t2014/09/23\thttps://vimeo.com/ondemand/genron20140923"
	},
	{
		"title": "みんなもっと適当でいいんじゃね？——旅とネットと人生設計 東浩紀『弱いつながり』（幻冬舎）刊行記念トークショー第2弾",
		"members": [
			"ちきりん",
			"東浩紀"
		],
		"date": "2014/09/19",
		"url": "https://vimeo.com/ondemand/genron20140919",
		"rawString": "みんなもっと適当でいいんじゃね？——旅とネットと人生設計 東浩紀『弱いつながり』（幻冬舎）刊行記念トークショー第2弾\tちきりん、東浩紀\t2014/09/19\thttps://vimeo.com/ondemand/genron20140919"
	},
	{
		"title": "劇場2.0を演出する——俳優と観客、あるいはアイドルと観光客が日本を変える！",
		"members": [
			"高山明",
			"濱野智史",
			"東浩紀"
		],
		"date": "2014/09/17",
		"url": "https://vimeo.com/ondemand/genron20140917",
		"rawString": "劇場2.0を演出する——俳優と観客、あるいはアイドルと観光客が日本を変える！\t高山明、濱野智史、東浩紀\t2014/09/17\thttps://vimeo.com/ondemand/genron20140917"
	},
	{
		"title": "2020年の東京と日本——クール・ジャパンでどこまでいけるのか",
		"members": [
			"桐島ローランド",
			"東浩紀"
		],
		"date": "2014/09/16",
		"url": "https://vimeo.com/ondemand/genron20140916",
		"rawString": "2020年の東京と日本——クール・ジャパンでどこまでいけるのか\t桐島ローランド、東浩紀\t2014/09/16\thttps://vimeo.com/ondemand/genron20140916"
	},
	{
		"title": "ウェブで政治は動かせるのか？",
		"members": [
			"佐々木俊尚",
			"東浩紀"
		],
		"date": "2014/09/12",
		"url": "https://vimeo.com/ondemand/genron20140912",
		"rawString": "ウェブで政治は動かせるのか？\t佐々木俊尚、東浩紀\t2014/09/12\thttps://vimeo.com/ondemand/genron20140912"
	},
	{
		"title": "デモの現在と未来——それでも社会は変わるのか",
		"members": [
			"五野井郁夫",
			"東浩紀"
		],
		"date": "2014/09/05",
		"url": "https://vimeo.com/ondemand/genron20140905",
		"rawString": "デモの現在と未来——それでも社会は変わるのか\t五野井郁夫、東浩紀\t2014/09/05\thttps://vimeo.com/ondemand/genron20140905"
	},
	{
		"title": "【大森望のSF喫茶 #7】SFアイドル、五反田に降臨！西田藍（講談社ミスiD2013準グランプリ）初の単独イベントがゲンロンカフェで実現。ディープなSFトーク＆リクエスト朗読＆初めての2ショットチェキ撮影会!!",
		"members": [
			"大森望",
			"西田藍"
		],
		"date": "2014/08/28",
		"url": "https://vimeo.com/ondemand/genron20140828",
		"rawString": "【大森望のSF喫茶 #7】SFアイドル、五反田に降臨！西田藍（講談社ミスiD2013準グランプリ）初の単独イベントがゲンロンカフェで実現。ディープなSFトーク＆リクエスト朗読＆初めての2ショットチェキ撮影会!!\t大森望、西田藍\t2014/08/28\thttps://vimeo.com/ondemand/genron20140828"
	},
	{
		"title": "【物語と観客の日本文明論——『復興文化論』の先へ #2】折口信夫から井筒俊彦へ——日本的な「物語」とその彼方",
		"members": [
			"福嶋亮大",
			"安藤礼二"
		],
		"date": "2014/08/22",
		"url": "https://vimeo.com/ondemand/genron20140822",
		"rawString": "【物語と観客の日本文明論——『復興文化論』の先へ #2】折口信夫から井筒俊彦へ——日本的な「物語」とその彼方\t福嶋亮大、安藤礼二\t2014/08/22\thttps://vimeo.com/ondemand/genron20140822"
	},
	{
		"title": "アナ雪騒動とアイドルから考える文学の行方——10年代の言論の自由？！",
		"members": [
			"市川真人",
			"中森明夫"
		],
		"date": "2014/08/21",
		"url": "https://vimeo.com/ondemand/genron20140821",
		"rawString": "アナ雪騒動とアイドルから考える文学の行方——10年代の言論の自由？！\t市川真人、中森明夫\t2014/08/21\thttps://vimeo.com/ondemand/genron20140821"
	},
	{
		"title": "いま「政治参加」とはなにか？——長期政権下における知識人の使命",
		"members": [
			"田原総一朗",
			"東浩紀",
			"津田大介"
		],
		"date": "2014/08/18",
		"url": "https://vimeo.com/ondemand/genron20140818",
		"rawString": "いま「政治参加」とはなにか？——長期政権下における知識人の使命\t田原総一朗、東浩紀、津田大介\t2014/08/18\thttps://vimeo.com/ondemand/genron20140818"
	},
	{
		"title": "【福島はいま #2】浜通りから考える新しい公共性——原町無線塔展クロージングトーク",
		"members": [
			"小松理虔",
			"東浩紀"
		],
		"date": "2014/08/09",
		"url": "https://vimeo.com/ondemand/genron20140809",
		"rawString": "【福島はいま #2】浜通りから考える新しい公共性——原町無線塔展クロージングトーク\t小松理虔、東浩紀\t2014/08/09\thttps://vimeo.com/ondemand/genron20140809"
	},
	{
		"title": "ダークツーリズムとアーカイブから考えるヒロシマ——記憶と未来をつなぐ旅",
		"members": [
			"井出明",
			"渡邉英徳"
		],
		"date": "2014/08/06",
		"url": "https://vimeo.com/ondemand/genron20140806",
		"rawString": "ダークツーリズムとアーカイブから考えるヒロシマ——記憶と未来をつなぐ旅\t井出明、渡邉英徳\t2014/08/06\thttps://vimeo.com/ondemand/genron20140806"
	},
	{
		"title": "【ニッポンの脳 #2】バカをバカと言える社会にどう変える？——日本再生の新・学問論",
		"members": [
			"茂木健一郎",
			"東浩紀"
		],
		"date": "2014/08/05",
		"url": "https://vimeo.com/ondemand/genron20140805",
		"rawString": "【ニッポンの脳 #2】バカをバカと言える社会にどう変える？——日本再生の新・学問論\t茂木健一郎、東浩紀\t2014/08/05\thttps://vimeo.com/ondemand/genron20140805"
	},
	{
		"title": "生物学はどこまで自由になれるのか？——DIYバイオの可能性",
		"members": [
			"堀川大樹",
			"岩崎秀雄",
			"東浩紀"
		],
		"date": "2014/07/30",
		"url": "https://vimeo.com/ondemand/genron20140730",
		"rawString": "生物学はどこまで自由になれるのか？——DIYバイオの可能性\t堀川大樹、岩崎秀雄、東浩紀\t2014/07/30\thttps://vimeo.com/ondemand/genron20140730"
	},
	{
		"title": "【大森望のSF喫茶 #6】SF編集者頂上対決——『S-Fマガジン』700号vs東京創元社60周年",
		"members": [
			"大森望",
			"塩澤快浩",
			"小浜徹也"
		],
		"date": "2014/07/24",
		"url": "https://vimeo.com/ondemand/genron20140724",
		"rawString": "【大森望のSF喫茶 #6】SF編集者頂上対決——『S-Fマガジン』700号vs東京創元社60周年\t大森望、塩澤快浩、小浜徹也\t2014/07/24\thttps://vimeo.com/ondemand/genron20140724"
	},
	{
		"title": "【ポストスーパーフラット・アートスクール Day 9】家入一真と語る「ITビジネスとアート」",
		"members": [
			"黒瀬陽平",
			"家入一真"
		],
		"date": "2014/07/20",
		"url": "https://vimeo.com/ondemand/genron20140720",
		"rawString": "【ポストスーパーフラット・アートスクール Day 9】家入一真と語る「ITビジネスとアート」\t黒瀬陽平、家入一真\t2014/07/20\thttps://vimeo.com/ondemand/genron20140720"
	},
	{
		"title": "STAP現象は本当にあったのか——再生医学が見る夢、見させられる夢",
		"members": [
			"関由行",
			"八代嘉美",
			"東浩紀"
		],
		"date": "2014/07/18",
		"url": "https://vimeo.com/ondemand/genron20140718",
		"rawString": "STAP現象は本当にあったのか——再生医学が見る夢、見させられる夢\t関由行、八代嘉美、東浩紀\t2014/07/18\thttps://vimeo.com/ondemand/genron20140718"
	},
	{
		"title": "【さやわか式☆現代文化論 #9】コミュニケーションは想像力を超えるか——ゼロ年代の終わりと10年代の行方",
		"members": [
			"さやわか",
			"海猫沢めろん",
			"東浩紀"
		],
		"date": "2014/07/12",
		"url": "https://vimeo.com/ondemand/genron20140712",
		"rawString": "【さやわか式☆現代文化論 #9】コミュニケーションは想像力を超えるか——ゼロ年代の終わりと10年代の行方\tさやわか、海猫沢めろん、東浩紀\t2014/07/12\thttps://vimeo.com/ondemand/genron20140712"
	},
	{
		"title": "【演劇を拡張する #3】「思想としてのテレビ」から演劇へ——接続と展開",
		"members": [
			"高山明",
			"今野勉"
		],
		"date": "2014/07/09",
		"url": "https://vimeo.com/ondemand/genron20140709",
		"rawString": "【演劇を拡張する #3】「思想としてのテレビ」から演劇へ——接続と展開\t高山明、今野勉\t2014/07/09\thttps://vimeo.com/ondemand/genron20140709"
	},
	{
		"title": "【物語と観客の日本文明論——『復興文化論』の先へ #1】日本の〈物語〉とポップカルチャー",
		"members": [
			"福嶋亮大"
		],
		"date": "2014/07/04",
		"url": "https://vimeo.com/ondemand/genron20140704",
		"rawString": "【物語と観客の日本文明論——『復興文化論』の先へ #1】日本の〈物語〉とポップカルチャー\t福嶋亮大\t2014/07/04\thttps://vimeo.com/ondemand/genron20140704"
	},
	{
		"title": "断ち切られたゼロ年代——2010年代に文学と思想は交わるのか？",
		"members": [
			"阿部和重",
			"東浩紀"
		],
		"date": "2014/06/27",
		"url": "https://vimeo.com/ondemand/genron20140627",
		"rawString": "断ち切られたゼロ年代——2010年代に文学と思想は交わるのか？\t阿部和重、東浩紀\t2014/06/27\thttps://vimeo.com/ondemand/genron20140627"
	},
	{
		"title": "【2045年の日本を構想する #1】ギートステイトふたたび——あの伝説の対談が帰ってきた！ 理系代表・清水亮（1976年生）と文系代表・東浩紀（1971年生）が縦横無尽に語る「ぼくたちが見たい理想の未来",
		"members": [
			"清水亮",
			"東浩紀",
			"速水健朗"
		],
		"date": "2014/06/25",
		"url": "https://vimeo.com/ondemand/genron20140625",
		"rawString": "【2045年の日本を構想する #1】ギートステイトふたたび——あの伝説の対談が帰ってきた！ 理系代表・清水亮（1976年生）と文系代表・東浩紀（1971年生）が縦横無尽に語る「ぼくたちが見たい理想の未来\t清水亮、東浩紀、速水健朗\t2014/06/25\thttps://vimeo.com/ondemand/genron20140625"
	},
	{
		"title": "原発事故のあと、哲学は可能か——森から始まる新しい「超越」を考える",
		"members": [
			"中沢新一",
			"東浩紀"
		],
		"date": "2014/06/22",
		"url": "https://vimeo.com/ondemand/genron20140622",
		"rawString": "原発事故のあと、哲学は可能か——森から始まる新しい「超越」を考える\t中沢新一、東浩紀\t2014/06/22\thttps://vimeo.com/ondemand/genron20140622"
	},
	{
		"title": "【さやわか式☆現代文化論 #8】カゲロウプロジェクトの真実！",
		"members": [
			"さやわか",
			"村上裕一"
		],
		"date": "2014/06/21",
		"url": "https://vimeo.com/ondemand/genron20140621",
		"rawString": "【さやわか式☆現代文化論 #8】カゲロウプロジェクトの真実！\tさやわか、村上裕一\t2014/06/21\thttps://vimeo.com/ondemand/genron20140621"
	},
	{
		"title": "【日本精神分析2.0 #5】日本語はなぜ「現実」から乖離するのか",
		"members": [
			"斎藤環"
		],
		"date": "2014/06/20",
		"url": "https://vimeo.com/ondemand/genron20140620",
		"rawString": "【日本精神分析2.0 #5】日本語はなぜ「現実」から乖離するのか\t斎藤環\t2014/06/20\thttps://vimeo.com/ondemand/genron20140620"
	},
	{
		"title": "【大森望のSF喫茶 #5】テクノロジーとSF 20分後の未来",
		"members": [
			"大森望",
			"藤井太洋"
		],
		"date": "2014/06/19",
		"url": "https://vimeo.com/ondemand/genron20140619",
		"rawString": "【大森望のSF喫茶 #5】テクノロジーとSF 20分後の未来\t大森望、藤井太洋\t2014/06/19\thttps://vimeo.com/ondemand/genron20140619"
	},
	{
		"title": "東京から世界文学空間へ：接続と断絶——『世界の読者に伝えるということ』出版記念トークイベント",
		"members": [
			"河野至恩",
			"上田洋子"
		],
		"date": "2014/06/14",
		"url": "https://vimeo.com/ondemand/genron20140614",
		"rawString": "東京から世界文学空間へ：接続と断絶——『世界の読者に伝えるということ』出版記念トークイベント\t河野至恩、上田洋子\t2014/06/14\thttps://vimeo.com/ondemand/genron20140614"
	},
	{
		"title": "民族か、市民か？——激動のウクライナから国家のありかたを問う",
		"members": [
			"服部倫卓",
			"東浩紀",
			"上田洋子"
		],
		"date": "2014/06/11",
		"url": "https://vimeo.com/ondemand/genron20140611",
		"rawString": "民族か、市民か？——激動のウクライナから国家のありかたを問う\t服部倫卓、東浩紀、上田洋子\t2014/06/11\thttps://vimeo.com/ondemand/genron20140611"
	},
	{
		"title": "ビットコインは貨幣たりうるか——匿名と安全と流通のバランスをめぐって",
		"members": [
			"楠正憲",
			"山口浩",
			"東浩紀"
		],
		"date": "2014/06/05",
		"url": "https://vimeo.com/ondemand/genron20140605",
		"rawString": "ビットコインは貨幣たりうるか——匿名と安全と流通のバランスをめぐって\t楠正憲、山口浩、東浩紀\t2014/06/05\thttps://vimeo.com/ondemand/genron20140605"
	},
	{
		"title": "【演劇を拡張する #2】「観客席」から考える——「運営の時代」の演劇的想像力",
		"members": [
			"高山明",
			"黒瀬陽平"
		],
		"date": "2014/06/04",
		"url": "https://vimeo.com/ondemand/genron20140604",
		"rawString": "【演劇を拡張する #2】「観客席」から考える——「運営の時代」の演劇的想像力\t高山明、黒瀬陽平\t2014/06/04\thttps://vimeo.com/ondemand/genron20140604"
	},
	{
		"title": "【『存在論的、郵便的』を読む #4】2つの手紙、2つの脱構築、そして2つの人生",
		"members": [
			"東浩紀"
		],
		"date": "2014/05/31",
		"url": "https://vimeo.com/ondemand/genron20140531",
		"rawString": "【『存在論的、郵便的』を読む #4】2つの手紙、2つの脱構築、そして2つの人生\t東浩紀\t2014/05/31\thttps://vimeo.com/ondemand/genron20140531"
	},
	{
		"title": "ゴムとタブーとATOMAGE——サエボーグ岡本敏子賞&五反田アート賞受賞記念パフォーマンス＆トークショー",
		"members": [
			"サエボーグ",
			"黒瀬陽平"
		],
		"date": "2014/05/24",
		"url": "https://vimeo.com/ondemand/genron20140524",
		"rawString": "ゴムとタブーとATOMAGE——サエボーグ岡本敏子賞&五反田アート賞受賞記念パフォーマンス＆トークショー\tサエボーグ、黒瀬陽平\t2014/05/24\thttps://vimeo.com/ondemand/genron20140524"
	},
	{
		"title": "【大森望のSF喫茶 #4】いま解き明かす『皆勤の徒』のすべて",
		"members": [
			"大森望",
			"酉島伝法"
		],
		"date": "2014/05/22",
		"url": "https://vimeo.com/ondemand/genron20140522",
		"rawString": "【大森望のSF喫茶 #4】いま解き明かす『皆勤の徒』のすべて\t大森望、酉島伝法\t2014/05/22\thttps://vimeo.com/ondemand/genron20140522"
	},
	{
		"title": "アイロニーは国を滅ぼすのか？—— 『ネトウヨ化する日本』刊行記念",
		"members": [
			"村上裕一",
			"東浩紀"
		],
		"date": "2014/05/21",
		"url": "https://vimeo.com/ondemand/genron20140521",
		"rawString": "アイロニーは国を滅ぼすのか？—— 『ネトウヨ化する日本』刊行記念\t村上裕一、東浩紀\t2014/05/21\thttps://vimeo.com/ondemand/genron20140521"
	},
	{
		"title": "【『批評空間』以降に文学は？：市川真人の現代文学講座 #1】ジャンルを超えること、文学であること",
		"members": [
			"奥泉光",
			"市川真人"
		],
		"date": "2014/05/17",
		"url": "https://vimeo.com/ondemand/genron20140517",
		"rawString": "【『批評空間』以降に文学は？：市川真人の現代文学講座 #1】ジャンルを超えること、文学であること\t奥泉光、市川真人\t2014/05/17\thttps://vimeo.com/ondemand/genron20140517"
	},
	{
		"title": "【ショッピングモールから考える #2】内と外が逆転した新たなユートピア",
		"members": [
			"大山顕",
			"東浩紀"
		],
		"date": "2014/05/16",
		"url": "https://vimeo.com/ondemand/genron20140516",
		"rawString": "【ショッピングモールから考える #2】内と外が逆転した新たなユートピア\t大山顕、東浩紀\t2014/05/16\thttps://vimeo.com/ondemand/genron20140516"
	},
	{
		"title": "【さやわか式☆現代文化論 #7】セカイ系は2010年代も生き残るか",
		"members": [
			"さやわか",
			"前島賢"
		],
		"date": "2014/05/10",
		"url": "https://vimeo.com/ondemand/genron20140510",
		"rawString": "【さやわか式☆現代文化論 #7】セカイ系は2010年代も生き残るか\tさやわか、前島賢\t2014/05/10\thttps://vimeo.com/ondemand/genron20140510"
	},
	{
		"title": "【演劇を拡張する #1】いま、高山明が語る演劇原論",
		"members": [
			"高山明"
		],
		"date": "2014/05/07",
		"url": "https://vimeo.com/ondemand/genron20140507",
		"rawString": "【演劇を拡張する #1】いま、高山明が語る演劇原論\t高山明\t2014/05/07\thttps://vimeo.com/ondemand/genron20140507"
	},
	{
		"title": "【憲法2.0再起動 #1】憲法から考える国のかたち——人権、統治、平和主義",
		"members": [
			"小林節",
			"境真良",
			"西田亮介",
			"東浩紀"
		],
		"date": "2014/05/03",
		"url": "https://vimeo.com/ondemand/genron20140503",
		"rawString": "【憲法2.0再起動 #1】憲法から考える国のかたち——人権、統治、平和主義\t小林節、境真良、西田亮介、東浩紀\t2014/05/03\thttps://vimeo.com/ondemand/genron20140503"
	},
	{
		"title": "時を超えるアート——美術の復興／復興の美術",
		"members": [
			"岡﨑乾二郎",
			"東浩紀",
			"黒瀬陽平"
		],
		"date": "2014/04/26",
		"url": "https://vimeo.com/ondemand/genron20140426",
		"rawString": "時を超えるアート——美術の復興／復興の美術\t岡﨑乾二郎、東浩紀、黒瀬陽平\t2014/04/26\thttps://vimeo.com/ondemand/genron20140426"
	},
	{
		"title": "【日本精神分析2.0 #3】日本的中間集団（タテ社会、ムラ、世間　etc.）について",
		"members": [
			"斎藤環"
		],
		"date": "2014/04/25",
		"url": "https://vimeo.com/ondemand/genron20140425",
		"rawString": " 【日本精神分析2.0 #3】日本的中間集団（タテ社会、ムラ、世間　etc.）について \t斎藤環\t2014/04/25\thttps://vimeo.com/ondemand/genron20140425"
	},
	{
		"title": "世界を動かすファッション——「ファッションの魔法」を取り戻すために",
		"members": [
			"山縣良和",
			"坂部三樹郎",
			"黒瀬陽平"
		],
		"date": "2014/04/23",
		"url": "https://vimeo.com/ondemand/genron20140423",
		"rawString": "世界を動かすファッション——「ファッションの魔法」を取り戻すために\t山縣良和、坂部三樹郎、黒瀬陽平\t2014/04/23\thttps://vimeo.com/ondemand/genron20140423"
	},
	{
		"title": "生き延びるための精神分析——『頑張って生きるのが嫌な人のための本』発売記念トークイベント",
		"members": [
			"海猫沢めろん",
			"斎藤環"
		],
		"date": "2014/04/20",
		"url": "https://vimeo.com/ondemand/genron20140420",
		"rawString": "生き延びるための精神分析——『頑張って生きるのが嫌な人のための本』発売記念トークイベント\t海猫沢めろん、斎藤環\t2014/04/20\thttps://vimeo.com/ondemand/genron20140420"
	},
	{
		"title": "ポスト311の「トーキョー」――東京五輪の文化プログラムをどう世界に開くか",
		"members": [
			"相馬千秋",
			"東浩紀",
			"上田洋子"
		],
		"date": "2014/04/19",
		"url": "https://vimeo.com/ondemand/genron20140419",
		"rawString": "ポスト311の「トーキョー」――東京五輪の文化プログラムをどう世界に開くか\t相馬千秋、東浩紀、上田洋子\t2014/04/19\thttps://vimeo.com/ondemand/genron20140419"
	},
	{
		"title": "エロマンガは政治的に正しいか——『増補 エロマンガ・スタディーズ』発刊記念",
		"members": [
			"永山薫",
			"久田将義",
			"東浩紀"
		],
		"date": "2014/04/18",
		"url": "https://vimeo.com/ondemand/genron20140418",
		"rawString": "エロマンガは政治的に正しいか——『増補 エロマンガ・スタディーズ』発刊記念\t永山薫、久田将義、東浩紀\t2014/04/18\thttps://vimeo.com/ondemand/genron20140418"
	},
	{
		"title": "【さやわか式☆現代文化論 #6】初音ミクの真実！",
		"members": [
			"さやわか",
			"柴那典"
		],
		"date": "2014/04/06",
		"url": "https://vimeo.com/ondemand/genron20140406",
		"rawString": "【さやわか式☆現代文化論 #6】初音ミクの真実！\tさやわか、柴那典\t2014/04/06\thttps://vimeo.com/ondemand/genron20140406"
	},
	{
		"title": "【『存在論的、郵便的』を読む #3】東浩紀による東浩紀",
		"members": [
			"東浩紀"
		],
		"date": "2014/04/05",
		"url": "https://vimeo.com/ondemand/genron20140405",
		"rawString": "【『存在論的、郵便的』を読む #3】東浩紀による東浩紀\t東浩紀\t2014/04/05\thttps://vimeo.com/ondemand/genron20140405"
	},
	{
		"title": "サイコパスの哲学へ——欲望と暴力について",
		"members": [
			"小泉義之",
			"千葉雅也",
			"東浩紀"
		],
		"date": "2014/04/04",
		"url": "https://vimeo.com/ondemand/genron20140404",
		"rawString": "サイコパスの哲学へ——欲望と暴力について\t小泉義之、千葉雅也、東浩紀\t2014/04/04\thttps://vimeo.com/ondemand/genron20140404"
	},
	{
		"title": "【日本精神分析2.0 #2】",
		"members": [
			"斎藤環",
			"東浩紀"
		],
		"date": "2014/03/28",
		"url": "https://vimeo.com/ondemand/genron20140328",
		"rawString": "【日本精神分析2.0 #2】\t斎藤環、東浩紀\t2014/03/28\thttps://vimeo.com/ondemand/genron20140328"
	},
	{
		"title": "ドストエフスキーからソローキンへ——ロシア・ユートピアの現在形",
		"members": [
			"市川真人",
			"東浩紀",
			"上田洋子"
		],
		"date": "2014/03/25",
		"url": "https://vimeo.com/ondemand/genron20140325",
		"rawString": "ドストエフスキーからソローキンへ——ロシア・ユートピアの現在形\t市川真人、東浩紀、上田洋子\t2014/03/25\thttps://vimeo.com/ondemand/genron20140325"
	},
	{
		"title": "アートから建築へ、そしてツーリズムへ——「揺れる大地」と「ゾーン」への旅",
		"members": [
			"五十嵐太郎",
			"藤村龍至",
			"東浩紀"
		],
		"date": "2014/03/21",
		"url": "https://vimeo.com/ondemand/genron20140321",
		"rawString": "アートから建築へ、そしてツーリズムへ——「揺れる大地」と「ゾーン」への旅\t五十嵐太郎、藤村龍至、東浩紀\t2014/03/21\thttps://vimeo.com/ondemand/genron20140321"
	},
	{
		"title": "建築は震災でなにをすべきだったのか——福島第一原発観光地化計画が問いかけるもの",
		"members": [
			"隈研吾",
			"藤村龍至",
			"東浩紀"
		],
		"date": "2014/03/19",
		"url": "https://vimeo.com/ondemand/genron20140319",
		"rawString": "建築は震災でなにをすべきだったのか——福島第一原発観光地化計画が問いかけるもの\t隈研吾、藤村龍至、東浩紀\t2014/03/19\thttps://vimeo.com/ondemand/genron20140319"
	},
	{
		"title": "科学と社会のコミュニケーションを考える——STAP細胞をめぐって",
		"members": [
			"八代嘉美",
			"東浩紀"
		],
		"date": "2014/03/16",
		"url": "https://vimeo.com/ondemand/genron20140316",
		"rawString": "科学と社会のコミュニケーションを考える——STAP細胞をめぐって\t八代嘉美、東浩紀\t2014/03/16\thttps://vimeo.com/ondemand/genron20140316"
	},
	{
		"title": "ふたたび謎解きの世界——名探偵と愛のゆくえ",
		"members": [
			"法月綸太郎",
			"東浩紀"
		],
		"date": "2014/03/14",
		"url": "https://vimeo.com/ondemand/genron20140314",
		"rawString": "ふたたび謎解きの世界——名探偵と愛のゆくえ\t法月綸太郎、東浩紀\t2014/03/14\thttps://vimeo.com/ondemand/genron20140314"
	},
	{
		"title": "【さやわか式☆現代文化論 #5】アイドル／運営の現在",
		"members": [
			"さやわか",
			"もふくちゃん（福嶋麻衣子）"
		],
		"date": "2014/03/08",
		"url": "https://vimeo.com/ondemand/genron20140308",
		"rawString": "【さやわか式☆現代文化論 #5】アイドル／運営の現在\tさやわか、もふくちゃん（福嶋麻衣子）\t2014/03/08\thttps://vimeo.com/ondemand/genron20140308"
	},
	{
		"title": "批評における居心地の悪さ",
		"members": [
			"千葉雅也",
			"平倉圭"
		],
		"date": "2014/03/07",
		"url": "https://vimeo.com/ondemand/genron20140307",
		"rawString": "批評における居心地の悪さ\t千葉雅也、平倉圭\t2014/03/07\thttps://vimeo.com/ondemand/genron20140307"
	},
	{
		"title": "”教養としてのプログラミング”を考える",
		"members": [
			"清水亮"
		],
		"date": "2014/03/06",
		"url": "https://vimeo.com/ondemand/genron20140306",
		"rawString": "”教養としてのプログラミング”を考える\t清水亮\t2014/03/06\thttps://vimeo.com/ondemand/genron20140306"
	},
	{
		"title": "アーキテクチャからアイドルへ——platonicsの新しい挑戦",
		"members": [
			"濱野智史",
			"東浩紀"
		],
		"date": "2014/03/02",
		"url": "https://vimeo.com/ondemand/genron20140302",
		"rawString": "アーキテクチャからアイドルへ——platonicsの新しい挑戦\t濱野智史、東浩紀\t2014/03/02\thttps://vimeo.com/ondemand/genron20140302"
	},
	{
		"title": "観光と演劇は社会を変えるか——Port B観光リサーチセンターと福島第一原発観光地化計画の未来",
		"members": [
			"高山明",
			"東浩紀"
		],
		"date": "2014/02/26",
		"url": "https://vimeo.com/ondemand/genron20140226",
		"rawString": "観光と演劇は社会を変えるか——Port B観光リサーチセンターと福島第一原発観光地化計画の未来\t高山明、東浩紀\t2014/02/26\thttps://vimeo.com/ondemand/genron20140226"
	},
	{
		"title": "2014年の柄谷行人、あるいは回帰する「政治と文学」",
		"members": [
			"仲山ひふみ",
			"倉津拓也"
		],
		"date": "2014/02/23",
		"url": "https://vimeo.com/ondemand/genron20140223",
		"rawString": "2014年の柄谷行人、あるいは回帰する「政治と文学」\t仲山ひふみ、倉津拓也\t2014/02/23\thttps://vimeo.com/ondemand/genron20140223"
	},
	{
		"title": "「フクシマ」は思想的課題になりうるか——震災後の日本を振り返る",
		"members": [
			"浅田彰",
			"東浩紀"
		],
		"date": "2014/02/22",
		"url": "https://vimeo.com/ondemand/genron20140222",
		"rawString": "「フクシマ」は思想的課題になりうるか——震災後の日本を振り返る\t浅田彰、東浩紀\t2014/02/22\thttps://vimeo.com/ondemand/genron20140222"
	},
	{
		"title": "【さやわか式☆現代文化論 #4】このマンガ語りがすごい！2014",
		"members": [
			"さやわか",
			"中田健太郎",
			"伊藤剛"
		],
		"date": "2014/02/14",
		"url": "https://vimeo.com/ondemand/genron20140214",
		"rawString": "【さやわか式☆現代文化論 #4】このマンガ語りがすごい！2014\tさやわか、中田健太郎、伊藤剛\t2014/02/14\thttps://vimeo.com/ondemand/genron20140214"
	},
	{
		"title": "【フード左翼講座 ～消費と政治、その分かち難いランデブーのゆくえ～ #1】西海岸イデオロギーとヴィーガン文化",
		"members": [
			"速水健朗",
			"松島倫明"
		],
		"date": "2014/02/13",
		"url": "https://vimeo.com/ondemand/genron20140213",
		"rawString": "【フード左翼講座 ～消費と政治、その分かち難いランデブーのゆくえ～ #1】西海岸イデオロギーとヴィーガン文化\t速水健朗、松島倫明\t2014/02/13\thttps://vimeo.com/ondemand/genron20140213"
	},
	{
		"title": "希望のつくり方——ネット・教育・都知事選",
		"members": [
			"乙武洋匡",
			"津田大介",
			"東浩紀"
		],
		"date": "2014/02/12",
		"url": "https://vimeo.com/ondemand/genron20140212",
		"rawString": "希望のつくり方——ネット・教育・都知事選\t乙武洋匡、津田大介、東浩紀\t2014/02/12\thttps://vimeo.com/ondemand/genron20140212"
	},
	{
		"title": "ドゥルーズとマイノリティ——紀伊國屋じんぶん大賞受賞記念講義",
		"members": [
			"千葉雅也"
		],
		"date": "2014/02/06",
		"url": "https://vimeo.com/ondemand/genron20140206",
		"rawString": "ドゥルーズとマイノリティ——紀伊國屋じんぶん大賞受賞記念講義\t千葉雅也\t2014/02/06\thttps://vimeo.com/ondemand/genron20140206"
	},
	{
		"title": "≪名前のない性≫をイメージする——セクシャルマイノリティの現状からの思考",
		"members": [
			"牧村朝子",
			"東浩紀"
		],
		"date": "2014/01/31",
		"url": "https://vimeo.com/ondemand/genron20140131",
		"rawString": "≪名前のない性≫をイメージする——セクシャルマイノリティの現状からの思考\t牧村朝子、東浩紀\t2014/01/31\thttps://vimeo.com/ondemand/genron20140131"
	},
	{
		"title": "【ショッピングモールから考える #1】ショッピングモールから考える",
		"members": [
			"大山顕",
			"東浩紀"
		],
		"date": "2014/01/30",
		"url": "https://vimeo.com/ondemand/genron20140130",
		"rawString": "【ショッピングモールから考える #1】ショッピングモールから考える\t大山顕、東浩紀\t2014/01/30\thttps://vimeo.com/ondemand/genron20140130"
	},
	{
		"title": "マジック・ザ・ギャザリングの美学——なぜ「マジック」はこれほど人を惹きつけるのか？ 初心者も大歓迎！",
		"members": [
			"村上裕一",
			"Revin"
		],
		"date": "2014/01/29",
		"url": "https://vimeo.com/ondemand/genron20140129",
		"rawString": "マジック・ザ・ギャザリングの美学——なぜ「マジック」はこれほど人を惹きつけるのか？ 初心者も大歓迎！\t村上裕一、Revin\t2014/01/29\thttps://vimeo.com/ondemand/genron20140129"
	},
	{
		"title": "【ニッポンの脳 #1】東大は本当に要らないのか——哲学と脳から考える新・学歴社会論",
		"members": [
			"茂木健一郎",
			"東浩紀"
		],
		"date": "2014/01/25",
		"url": "https://vimeo.com/ondemand/genron20140125",
		"rawString": "【ニッポンの脳 #1】東大は本当に要らないのか——哲学と脳から考える新・学歴社会論\t茂木健一郎、東浩紀\t2014/01/25\thttps://vimeo.com/ondemand/genron20140125"
	},
	{
		"title": "ニッポンの展望——2013年総括＆2014年大予言！",
		"members": [
			"宮台真司",
			"東浩紀"
		],
		"date": "2014/01/18",
		"url": "https://vimeo.com/ondemand/genron20140118",
		"rawString": "ニッポンの展望——2013年総括＆2014年大予言！\t宮台真司、東浩紀\t2014/01/18\thttps://vimeo.com/ondemand/genron20140118"
	},
	{
		"title": "新たなセカイの記述法——ライトノベル、キャラクター、メディアミックス、そしてまだ見ぬ文学の形へ",
		"members": [
			"十文字青",
			"大間九郎",
			"坂上秋成"
		],
		"date": "2014/01/17",
		"url": "https://vimeo.com/ondemand/genron20140117",
		"rawString": "新たなセカイの記述法——ライトノベル、キャラクター、メディアミックス、そしてまだ見ぬ文学の形へ\t十文字青、大間九郎、坂上秋成\t2014/01/17\thttps://vimeo.com/ondemand/genron20140117"
	},
	{
		"title": "【『存在論的、郵便的』を読む #2】東浩紀による東浩紀",
		"members": [
			"東浩紀"
		],
		"date": "2014/01/15",
		"url": "https://vimeo.com/ondemand/genron20140115",
		"rawString": "【『存在論的、郵便的』を読む #2】東浩紀による東浩紀\t東浩紀\t2014/01/15\thttps://vimeo.com/ondemand/genron20140115"
	},
	{
		"title": "【大森望のSF喫茶 #2】SFと復興——小松左京から考える",
		"members": [
			"瀬名秀明",
			"大森望",
			"東浩紀"
		],
		"date": "2014/01/11",
		"url": "https://vimeo.com/ondemand/genron20140111",
		"rawString": "【大森望のSF喫茶 #2】SFと復興——小松左京から考える\t瀬名秀明、大森望、東浩紀\t2014/01/11\thttps://vimeo.com/ondemand/genron20140111"
	},
	{
		"title": "【さやわか式☆現代文化論 #3】ジブリアニメを語り尽くす！——「ナウシカ」から「かぐや姫」まで",
		"members": [
			"さやわか",
			"渡邉大輔",
			"ふみふみこ"
		],
		"date": "2014/01/10",
		"url": "https://vimeo.com/ondemand/genron20140110",
		"rawString": "【さやわか式☆現代文化論 #3】ジブリアニメを語り尽くす！——「ナウシカ」から「かぐや姫」まで\tさやわか、渡邉大輔、ふみふみこ\t2014/01/10\thttps://vimeo.com/ondemand/genron20140110"
	},
	{
		"title": "データを紡いで社会につなぐ——デジタルアーカイブのつくり方",
		"members": [
			"渡邉英徳"
		],
		"date": "2014/01/09",
		"url": "https://vimeo.com/ondemand/genron20140109",
		"rawString": "データを紡いで社会につなぐ——デジタルアーカイブのつくり方\t渡邉英徳\t2014/01/09\thttps://vimeo.com/ondemand/genron20140109"
	},
	{
		"title": "偶然を必然に変える力——『情報社会の情念』刊行記念！ 年内最終イベント！ そしてフクイチ展覧会クロージング！",
		"members": [
			"黒瀬陽平",
			"東浩紀"
		],
		"date": "2013/12/28",
		"url": "https://vimeo.com/ondemand/genron20131228",
		"rawString": "偶然を必然に変える力——『情報社会の情念』刊行記念！ 年内最終イベント！ そしてフクイチ展覧会クロージング！\t黒瀬陽平、東浩紀\t2013/12/28\thttps://vimeo.com/ondemand/genron20131228"
	},
	{
		"title": "本当の文芸評論の話をしよう：ジェンダー、キャラクター、想像力——『セカイからもっと近くに』（東京創元社）刊行記念",
		"members": [
			"市川真人",
			"東浩紀"
		],
		"date": "2013/12/18",
		"url": "https://vimeo.com/ondemand/genron20131218",
		"rawString": "本当の文芸評論の話をしよう：ジェンダー、キャラクター、想像力——『セカイからもっと近くに』（東京創元社）刊行記念\t市川真人、東浩紀\t2013/12/18\thttps://vimeo.com/ondemand/genron20131218"
	},
	{
		"title": "「復興文化」の意義を問う——傷だらけの世界で私たちが生きていくための冴えたやり方",
		"members": [
			"福嶋亮大",
			"東浩紀"
		],
		"date": "2013/12/15",
		"url": "https://vimeo.com/ondemand/genron20131215",
		"rawString": "「復興文化」の意義を問う——傷だらけの世界で私たちが生きていくための冴えたやり方\t福嶋亮大、東浩紀\t2013/12/15\thttps://vimeo.com/ondemand/genron20131215"
	},
	{
		"title": "来るべき民主主義——デリダ、ドゥルーズ、柄谷行人",
		"members": [
			"國分功一郎",
			"東浩紀"
		],
		"date": "2013/12/14",
		"url": "https://vimeo.com/ondemand/genron20131214",
		"rawString": "来るべき民主主義——デリダ、ドゥルーズ、柄谷行人\t國分功一郎、東浩紀\t2013/12/14\thttps://vimeo.com/ondemand/genron20131214"
	},
	{
		"title": "アートと哲学の交差点——あるいは2010年代におけるクリエイティヴィティについて",
		"members": [
			"千葉雅也",
			"黒瀬陽平",
			"坂上秋成",
			"東浩紀"
		],
		"date": "2013/12/13",
		"url": "https://vimeo.com/ondemand/genron20131213",
		"rawString": "アートと哲学の交差点——あるいは2010年代におけるクリエイティヴィティについて\t千葉雅也、黒瀬陽平、坂上秋成、東浩紀\t2013/12/13\thttps://vimeo.com/ondemand/genron20131213"
	},
	{
		"title": "2013年 井出明が歩いたダークツーリズムの旅",
		"members": [
			"井出明"
		],
		"date": "2013/12/08",
		"url": "https://vimeo.com/ondemand/genron20131208",
		"rawString": "2013年 井出明が歩いたダークツーリズムの旅\t井出明\t2013/12/08\thttps://vimeo.com/ondemand/genron20131208"
	},
	{
		"title": "【『存在論的、郵便的』を読む #1】東浩紀による東浩紀",
		"members": [
			"東浩紀"
		],
		"date": "2013/12/07",
		"url": "https://vimeo.com/ondemand/genron20131207",
		"rawString": "【『存在論的、郵便的』を読む #1】東浩紀による東浩紀\t東浩紀\t2013/12/07\thttps://vimeo.com/ondemand/genron20131207"
	},
	{
		"title": "ビジネスとしての福島第一原発観光地化計画——巨大な夢に対して実業家はどのような視点を向けるのか!?",
		"members": [
			"夏野剛",
			"東浩紀"
		],
		"date": "2013/12/03",
		"url": "https://vimeo.com/ondemand/genron20131203",
		"rawString": "ビジネスとしての福島第一原発観光地化計画——巨大な夢に対して実業家はどのような視点を向けるのか!?\t夏野剛、東浩紀\t2013/12/03\thttps://vimeo.com/ondemand/genron20131203"
	},
	{
		"title": "現場から考える——続・福島第一原発観光地化計画は「正しい」のか？",
		"members": [
			"久田将義",
			"津田大介"
		],
		"date": "2013/12/01",
		"url": "https://vimeo.com/ondemand/genron20131201",
		"rawString": "現場から考える——続・福島第一原発観光地化計画は「正しい」のか？\t久田将義、津田大介\t2013/12/01\thttps://vimeo.com/ondemand/genron20131201"
	},
	{
		"title": "ユートピアの可能性——「福島第一原発観光化計画」の行方と日本社会の諸問題",
		"members": [
			"三浦展",
			"東浩紀",
			"藤村龍至"
		],
		"date": "2013/11/26",
		"url": "https://vimeo.com/ondemand/genron20131126",
		"rawString": "ユートピアの可能性——「福島第一原発観光化計画」の行方と日本社会の諸問題\t三浦展、東浩紀、藤村龍至\t2013/11/26\thttps://vimeo.com/ondemand/genron20131126"
	},
	{
		"title": "「関係しすぎない関係」を巡って——新たなるドゥルーズ、新たなる人間",
		"members": [
			"千葉雅也",
			"東浩紀"
		],
		"date": "2013/11/22",
		"url": "https://vimeo.com/ondemand/genron20131122",
		"rawString": "「関係しすぎない関係」を巡って——新たなるドゥルーズ、新たなる人間\t千葉雅也、東浩紀\t2013/11/22\thttps://vimeo.com/ondemand/genron20131122"
	},
	{
		"title": "震災から文学へ ゲンロンカフェ編",
		"members": [
			"市川真人",
			"高橋源一郎",
			"東浩紀"
		],
		"date": "2013/11/16",
		"url": "https://vimeo.com/ondemand/genron20131116",
		"rawString": "震災から文学へ ゲンロンカフェ編\t市川真人、高橋源一郎、東浩紀\t2013/11/16\thttps://vimeo.com/ondemand/genron20131116"
	},
	{
		"title": "福島第一原発観光地化計画と日本の未来",
		"members": [
			"小林よしのり",
			"東浩紀"
		],
		"date": "2013/11/09",
		"url": "https://vimeo.com/ondemand/genron20131109",
		"rawString": "福島第一原発観光地化計画と日本の未来\t小林よしのり、東浩紀\t2013/11/09\thttps://vimeo.com/ondemand/genron20131109"
	},
	{
		"title": "アウトローが潜む場所",
		"members": [
			"開沼博",
			"久田将義",
			"東浩紀"
		],
		"date": "2013/10/28",
		"url": "https://vimeo.com/ondemand/genron20131028",
		"rawString": "アウトローが潜む場所\t開沼博、久田将義、東浩紀\t2013/10/28\thttps://vimeo.com/ondemand/genron20131028"
	},
	{
		"title": "【「大停滞」時代の歴史学～日本はなぜ変われないのか #3】「歴史の終わり」論再考——“いま”の起源はどこにあるのか",
		"members": [
			"與那覇潤"
		],
		"date": "2013/10/26",
		"url": "https://vimeo.com/ondemand/genron20131026",
		"rawString": "【「大停滞」時代の歴史学～日本はなぜ変われないのか #3】「歴史の終わり」論再考——“いま”の起源はどこにあるのか\t與那覇潤\t2013/10/26\thttps://vimeo.com/ondemand/genron20131026"
	},
	{
		"title": "【ゼロ年代とはなんだったのか #2】伝説の「ゼロアカ道場」をサバイブしゲンロンカフェ新店長に就任する新進小説家が、師・東浩紀と語る「本当の」あの時代——ゼロアカ世代必見！事件勃発必至！おれたちの戦いは本当に始まるのか？",
		"members": [
			"坂上秋成",
			"東浩紀"
		],
		"date": "2013/10/23",
		"url": "https://vimeo.com/ondemand/genron20131023",
		"rawString": "【ゼロ年代とはなんだったのか #2】伝説の「ゼロアカ道場」をサバイブしゲンロンカフェ新店長に就任する新進小説家が、師・東浩紀と語る「本当の」あの時代——ゼロアカ世代必見！事件勃発必至！おれたちの戦いは本当に始まるのか？\t坂上秋成、東浩紀\t2013/10/23\thttps://vimeo.com/ondemand/genron20131023"
	},
	{
		"title": "【ゼロ年代とはなんだったのか #1】『ファウスト』を産み出した伝説の編集者×批評家タッグが語る「本当の」あの時代——ゼロアカ世代必見！奇跡の対談！おれたちの戦いはいま始まったばかりだ！",
		"members": [
			"太田克史",
			"東浩紀",
			"坂上秋成",
			"村上祐一",
			"峰尾俊彦",
			"廣田周作",
			"雑賀壱",
			"井上ざもすき"
		],
		"date": "2013/10/22",
		"url": "https://vimeo.com/ondemand/genron20131022",
		"rawString": "【ゼロ年代とはなんだったのか #1】『ファウスト』を産み出した伝説の編集者×批評家タッグが語る「本当の」あの時代——ゼロアカ世代必見！奇跡の対談！おれたちの戦いはいま始まったばかりだ！\t太田克史、東浩紀、坂上秋成、村上祐一、峰尾俊彦、廣田周作、雑賀壱、井上ざもすき\t2013/10/22\thttps://vimeo.com/ondemand/genron20131022"
	},
	{
		"title": "【福島第一原発観光地化計画の哲学——『一般意志2.0』とその後2 #2】",
		"members": [
			"東浩紀",
			"坂上秋成"
		],
		"date": "2013/10/15",
		"url": "https://vimeo.com/ondemand/genron20131015",
		"rawString": "【福島第一原発観光地化計画の哲学——『一般意志2.0』とその後2 #2】\t東浩紀、坂上秋成\t2013/10/15\thttps://vimeo.com/ondemand/genron20131015"
	},
	{
		"title": "【「大停滞」時代の歴史学～日本はなぜ変われないのか #2】「江戸時代化」論再考——日本は“いつから”変わらないのか",
		"members": [
			"與那覇潤"
		],
		"date": "2013/09/18",
		"url": "https://vimeo.com/ondemand/genron20130918",
		"rawString": "【「大停滞」時代の歴史学～日本はなぜ変われないのか #2】「江戸時代化」論再考——日本は“いつから”変わらないのか\t與那覇潤\t2013/09/18\thttps://vimeo.com/ondemand/genron20130918"
	},
	{
		"title": "チェルノブイリ再訪報告会——放射能災害からの復興(チェルノブイリ本刊行記念イベント第8弾)",
		"members": [
			"開沼博",
			"上田洋子",
			"東浩紀"
		],
		"date": "2013/09/07",
		"url": "https://vimeo.com/ondemand/genron20130907",
		"rawString": "チェルノブイリ再訪報告会——放射能災害からの復興(チェルノブイリ本刊行記念イベント第8弾)\t開沼博、上田洋子、東浩紀\t2013/09/07\thttps://vimeo.com/ondemand/genron20130907"
	},
	{
		"title": "東京から福島へ！「福島第一原発観光地化計画」提案の全貌とは？！——「アジアハザードセンター」「ふくしまゲートヴィレッジ」そして「福島災害博」",
		"members": [
			"藤村龍至",
			"東浩紀"
		],
		"date": "2013/09/06",
		"url": "https://vimeo.com/ondemand/genron20130906",
		"rawString": "東京から福島へ！「福島第一原発観光地化計画」提案の全貌とは？！——「アジアハザードセンター」「ふくしまゲートヴィレッジ」そして「福島災害博」\t藤村龍至、東浩紀\t2013/09/06\thttps://vimeo.com/ondemand/genron20130906"
	},
	{
		"title": "祝『スタートレック・イントゥ・ダークネス』公開！ 3人のSFオタクが今、改めて語り尽くす「スタートレック」",
		"members": [
			"大森望",
			"堺三保",
			"東浩紀"
		],
		"date": "2013/08/30",
		"url": "https://vimeo.com/ondemand/genron20130830",
		"rawString": "祝『スタートレック・イントゥ・ダークネス』公開！ 3人のSFオタクが今、改めて語り尽くす「スタートレック」\t大森望、堺三保、東浩紀\t2013/08/30\thttps://vimeo.com/ondemand/genron20130830"
	},
	{
		"title": "【大森望のSF喫茶 #1】火星のプリンセスは日本沈没の夢を見るか？",
		"members": [
			"大森望",
			"東浩紀"
		],
		"date": "2013/08/28",
		"url": "https://vimeo.com/ondemand/genron20130828",
		"rawString": "【大森望のSF喫茶 #1】火星のプリンセスは日本沈没の夢を見るか？\t大森望、東浩紀\t2013/08/28\thttps://vimeo.com/ondemand/genron20130828"
	},
	{
		"title": "【「大停滞」時代の歴史学～日本はなぜ変われないのか #1】「中国化」論再考——西洋化せずに、どこまでゆけるのか",
		"members": [
			"與那覇潤"
		],
		"date": "2013/08/21",
		"url": "https://vimeo.com/ondemand/genron20130821",
		"rawString": "【「大停滞」時代の歴史学～日本はなぜ変われないのか #1】「中国化」論再考——西洋化せずに、どこまでゆけるのか\t與那覇潤\t2013/08/21\thttps://vimeo.com/ondemand/genron20130821"
	},
	{
		"title": "【『一般意志2.0』とその後 #7】",
		"members": [
			"東浩紀"
		],
		"date": "2013/08/19",
		"url": "https://vimeo.com/ondemand/genron20130819",
		"rawString": "【『一般意志2.0』とその後 #7】\t東浩紀\t2013/08/19\thttps://vimeo.com/ondemand/genron20130819"
	},
	{
		"title": "ポストモダン以降の政治——ゲンロンカフェでついに実現、1対1の生討論！",
		"members": [
			"田原総一朗",
			"東浩紀"
		],
		"date": "2013/08/13",
		"url": "https://vimeo.com/ondemand/genron20130813",
		"rawString": "ポストモダン以降の政治——ゲンロンカフェでついに実現、1対1の生討論！\t田原総一朗、東浩紀\t2013/08/13\thttps://vimeo.com/ondemand/genron20130813"
	},
	{
		"title": "徹底討論！福島第一原発観光地化計画は「正しい」のか？——チェルノブイリ本刊行記念イベント第4弾",
		"members": [
			"久田将義",
			"津田大介",
			"東浩紀"
		],
		"date": "2013/08/02",
		"url": "https://vimeo.com/ondemand/genron20130802",
		"rawString": "徹底討論！福島第一原発観光地化計画は「正しい」のか？——チェルノブイリ本刊行記念イベント第4弾\t久田将義、津田大介、東浩紀\t2013/08/02\thttps://vimeo.com/ondemand/genron20130802"
	},
	{
		"title": "【『一般意志2.0』とその後 #6】",
		"members": [
			"東浩紀"
		],
		"date": "2013/07/26",
		"url": "https://vimeo.com/ondemand/genron20130726",
		"rawString": "【『一般意志2.0』とその後 #6】\t東浩紀\t2013/07/26\thttps://vimeo.com/ondemand/genron20130726"
	},
	{
		"title": "【SFに何ができるか——\"伊藤計劃以後\"の現代SF展望 #3】",
		"members": [
			"大森望"
		],
		"date": "2013/07/19",
		"url": "https://vimeo.com/ondemand/genron20130719",
		"rawString": "【SFに何ができるか——\"伊藤計劃以後\"の現代SF展望 #3】\t大森望\t2013/07/19\thttps://vimeo.com/ondemand/genron20130719"
	},
	{
		"title": "思想地図β4-1刊行記念！ チェルノブイリ萌え！？",
		"members": [
			"大山顕",
			"速水健朗",
			"東浩紀"
		],
		"date": "2013/07/18",
		"url": "https://vimeo.com/ondemand/genron20130718",
		"rawString": "思想地図β4-1刊行記念！ チェルノブイリ萌え！？\t大山顕、速水健朗、東浩紀\t2013/07/18\thttps://vimeo.com/ondemand/genron20130718"
	},
	{
		"title": "理系と文系がついに融合！enchantMOONとチェルノブイリ・ダークツーリズム・ガイド、2つまとめて発売記念イベントやっちゃいます",
		"members": [
			"清水亮",
			"東浩紀"
		],
		"date": "2013/07/07",
		"url": "https://vimeo.com/ondemand/genron20130707",
		"rawString": "理系と文系がついに融合！enchantMOONとチェルノブイリ・ダークツーリズム・ガイド、2つまとめて発売記念イベントやっちゃいます\t清水亮、東浩紀\t2013/07/07\thttps://vimeo.com/ondemand/genron20130707"
	},
	{
		"title": "楽園か、戦場か。「レイヤー化する世界」のサヴァイヴ術！",
		"members": [
			"佐々木俊尚",
			"東浩紀"
		],
		"date": "2013/06/29",
		"url": "https://vimeo.com/ondemand/genron20130629",
		"rawString": "楽園か、戦場か。「レイヤー化する世界」のサヴァイヴ術！\t佐々木俊尚、東浩紀\t2013/06/29\thttps://vimeo.com/ondemand/genron20130629"
	},
	{
		"title": "【『一般意志2.0』とその後 #5】",
		"members": [
			"東浩紀"
		],
		"date": "2013/06/24",
		"url": "https://vimeo.com/ondemand/genron20130624",
		"rawString": "【『一般意志2.0』とその後 #5】\t東浩紀\t2013/06/24\thttps://vimeo.com/ondemand/genron20130624"
	},
	{
		"title": "思想地図β4-1刊行記念！ チェルノブイリの現在、福島の未来",
		"members": [
			"宮台真司",
			"東浩紀"
		],
		"date": "2013/06/22",
		"url": "https://vimeo.com/ondemand/genron20130622",
		"rawString": "思想地図β4-1刊行記念！ チェルノブイリの現在、福島の未来\t宮台真司、東浩紀\t2013/06/22\thttps://vimeo.com/ondemand/genron20130622"
	},
	{
		"title": "【SFに何ができるか——\"伊藤計劃以後\"の現代SF展望 #2】",
		"members": [
			"大森望"
		],
		"date": "2013/06/21",
		"url": "https://vimeo.com/ondemand/genron20130621",
		"rawString": "【SFに何ができるか——\"伊藤計劃以後\"の現代SF展望 #2】\t大森望\t2013/06/21\thttps://vimeo.com/ondemand/genron20130621"
	},
	{
		"title": "【『一般意志2.0』とその後 #4】",
		"members": [
			"東浩紀"
		],
		"date": "2013/05/24",
		"url": "https://vimeo.com/ondemand/genron20130524",
		"rawString": "【『一般意志2.0』とその後 #4】\t東浩紀\t2013/05/24\thttps://vimeo.com/ondemand/genron20130524"
	},
	{
		"title": "来るべき民主主義——都道328号線問題と小平市住民投票から考える政治のこれから",
		"members": [
			"國分功一郎"
		],
		"date": "2013/05/03",
		"url": "https://vimeo.com/ondemand/genron20130503",
		"rawString": "来るべき民主主義——都道328号線問題と小平市住民投票から考える政治のこれから\t國分功一郎\t2013/05/03\thttps://vimeo.com/ondemand/genron20130503"
	},
	{
		"title": "【ギャル男から存在論へ：分離について #3】",
		"members": [
			"千葉雅也"
		],
		"date": "2013/04/26",
		"url": "https://vimeo.com/ondemand/genron20130426",
		"rawString": "【ギャル男から存在論へ：分離について #3】\t千葉雅也\t2013/04/26\thttps://vimeo.com/ondemand/genron20130426"
	},
	{
		"title": "【『一般意志2.0』とその後 #3】",
		"members": [
			"東浩紀"
		],
		"date": "2013/04/03",
		"url": "https://vimeo.com/ondemand/genron20130403",
		"rawString": "【『一般意志2.0』とその後 #3】\t東浩紀\t2013/04/03\thttps://vimeo.com/ondemand/genron20130403"
	},
	{
		"title": "フクシマからチェルノブイリへ",
		"members": [
			"開沼博",
			"津田大介",
			"東浩紀"
		],
		"date": "2013/03/30",
		"url": "https://vimeo.com/ondemand/genron20130330",
		"rawString": "フクシマからチェルノブイリへ\t開沼博、津田大介、東浩紀\t2013/03/30\thttps://vimeo.com/ondemand/genron20130330"
	},
	{
		"title": "【ギャル男から存在論へ：分離について #2】",
		"members": [
			"千葉雅也"
		],
		"date": "2013/03/22",
		"url": "https://vimeo.com/ondemand/genron20130322",
		"rawString": "【ギャル男から存在論へ：分離について #2】\t千葉雅也\t2013/03/22\thttps://vimeo.com/ondemand/genron20130322"
	},
	{
		"title": "【『一般意志2.0』とその後 #2】",
		"members": [
			"東浩紀"
		],
		"date": "2013/03/06",
		"url": "https://vimeo.com/ondemand/genron20130306",
		"rawString": "【『一般意志2.0』とその後 #2】\t東浩紀\t2013/03/06\thttps://vimeo.com/ondemand/genron20130306"
	},
	{
		"title": "【ギャル男から存在論へ：分離について #1】",
		"members": [
			"千葉雅也"
		],
		"date": "2013/02/22",
		"url": "https://vimeo.com/ondemand/genron20130222",
		"rawString": "【ギャル男から存在論へ：分離について #1】\t千葉雅也\t2013/02/22\thttps://vimeo.com/ondemand/genron20130222"
	},
	{
		"title": "【『一般意志2.0』とその後 #1】",
		"members": [
			"東浩紀"
		],
		"date": "2013/02/06",
		"url": "https://vimeo.com/ondemand/genron20130206",
		"rawString": "【『一般意志2.0』とその後 #1】\t東浩紀\t2013/02/06\thttps://vimeo.com/ondemand/genron20130206"
	}
]

export default json;
